<template>
  <div>
    <page-navigate></page-navigate>
    <div id="pageContainer">
      <section class="container1">
        <div class="flex contentBox justify-between ">
          <div class="left">
            <h1 class="super_large-80_bold md-title-32_bold word1">一键跟随<br class="pc">万亿级策略</h1>
            <h2 class="subtitle-20_regular md-body-14_regular word2">
              通过ETF CFD布局美股三大指数、科技成长、黄金矿<br class="pc">业等全球核心资产
            </h2>
            <div class="iconList body-14_regular  flex items-center">
              <div><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M1 5.5L4.61765 9L10.5 3" stroke="#A52933" stroke-width="2" />
                </svg>
                100+ ETF
              </div>
              <div><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M1 5.5L4.61765 9L10.5 3" stroke="#A52933" stroke-width="2" />
                </svg>
                5倍杠杆
              </div>
            </div>
            <a :href="signupUrl" target="_blank">
              <div class="pageBtn primary-default_large">
                <span class="word3">立即开户</span>
                <span class="iconfont icon-right"></span>
              </div>
            </a>
          </div>
          <img class="right" src="@/assets/image/trading-product/etf/headerModel.webp" alt="" />
        </div>
      </section>
      <product-tab></product-tab>
       <section class="shareHotModule">
      <picture class="shareHotModule-bg" aria-hidden="true">
        <source media="(max-width: 996px)" srcset="@/assets/image/trading-product/share-cfds/mgHotM.webp" />
        <img src="@/assets/image/trading-product/share-cfds/mgHot.webp" alt="" loading="lazy" />
      </picture>
      <div class="contentBox shareHotModule-content">
        <h2 class="title-32_bold md-title-24_bold shareHotModule-title scroll-fade-up">交易所有 ETF 产品</h2>

        <div class="shareHotModule-benefits title-64_bold md-title-32_bold scroll-fade-up">
          <span class="shareHotModule-benefit">
            <span class="shareHotModule-benefitNum">0</span><span class="shareHotModule-benefitText">手续费</span>
          </span>
          <span class="shareHotModule-benefit">
            <span class="shareHotModule-benefitNum">0</span><span class="shareHotModule-benefitText">隔夜利息</span>
          </span>
        </div>

        <div class="shareHotModule-countdown scroll-fade-up">
          <div class="body-14_regular md-body-14_regular shareHotModule-countdownLabel">活动结束倒计时（UTC+3）</div>
          <div class="shareHotModule-countdownRow">
            <div class="shareHotModule-timeBox"><span data-share-hot="days">--</span></div><span class="shareHotModule-unit">天</span>
            <div class="shareHotModule-timeBox"><span data-share-hot="hours">--</span></div><span class="shareHotModule-unit">时</span>
            <div class="shareHotModule-timeBox"><span data-share-hot="minutes">--</span></div><span class="shareHotModule-unit">分</span>
            <div class="shareHotModule-timeBox"><span data-share-hot="seconds">--</span></div>
          </div>
        </div>

        <a class="shareHotModule-ruleLink scroll-fade-up" href="javascript:;" data-share-hot-rule>
          <span class="shareHotModule-ruleText content-16_medium md-body-14_regular">查看活动规则</span>
          <svg class="shareHotModule-ruleIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7.07485 5.04079C6.82194 4.80595 6.80713 4.41035 7.04189 4.1574C7.27673 3.9045 7.67232 3.88969 7.92527 4.12444L13.7586 9.54111C13.886 9.65937 13.9584 9.82549 13.9584 9.99928C13.9584 10.1731 13.886 10.3392 13.7586 10.4575L7.92527 15.8741L7.87644 15.9152C7.62372 16.1062 7.26209 16.0783 7.04189 15.8412C6.82181 15.604 6.82096 15.2416 7.03009 15.0038L7.07485 14.9578L12.4146 9.99928L7.07485 5.04079Z" fill="white" fill-opacity="0.64"/>
          </svg>
        </a>
      </div>
    </section>

    <div class="shareHotRuleModal" id="shareHotRuleModal" aria-hidden="true">
      <div class="shareHotRuleModal-bg" data-share-hot-rule-close></div>
      <div class="shareHotRuleModal-dialog" role="dialog" aria-modal="true" aria-labelledby="shareHotRuleModalTitle" tabindex="-1">
        <button class="shareHotRuleModal-close" type="button" aria-label="关闭" data-share-hot-rule-close>
          <span class="iconfont icon-close"></span>
        </button>
        <h3 class="shareHotRuleModal-title title-32_bold md-title-24_bold" id="shareHotRuleModalTitle">活动规则</h3>
        <div class="shareHotRuleModal-body">
          <div class="shareHotRuleModal-item">
            <div class="shareHotRuleModal-itemTitle content-16_medium md-body-14_regular">活动时间</div>
            <div class="shareHotRuleModal-itemText body-14_regular md-body-14_regular">2026年6月12日 至 2026年9月11日（UTC+3）</div>
          </div>
          <div class="shareHotRuleModal-item">
            <div class="shareHotRuleModal-itemTitle content-16_medium md-body-14_regular">单笔限制</div>
            <div class="shareHotRuleModal-itemText body-14_regular md-body-14_regular">单个账号买入或卖出，单笔最大均为 50 股。</div>
          </div>
          <div class="shareHotRuleModal-item">
            <div class="shareHotRuleModal-itemTitle content-16_medium md-body-14_regular">持仓限制</div>
            <div class="shareHotRuleModal-itemText body-14_regular md-body-14_regular">单个账号、单个股票品种，买入方向与卖出方向持仓上限各为 1000 股。</div>
          </div>
          <div class="shareHotRuleModal-item">
            <div class="shareHotRuleModal-itemTitle content-16_medium md-body-14_regular">活动前后持仓说明</div>
            <div class="shareHotRuleModal-itemText body-14_regular md-body-14_regular">
              <p>6月12日前已有持仓，并在活动期间平仓，不收取平仓手续费。</p>
              <p>活动期间持仓，如在9月11日活动结束后平仓，平仓手续费按正常标准收取。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
      <section class="etf-efficient">
        <div class="contentBox etf-efficient__inner">
          <div class="etf-efficient__header scroll-fade-up">
            <h2 class="title-48_bold md-title-24_bold">高效的 ETF 交易环境</h2>
            <h3 class="subtitle-20_regular md-footnote-regular_12">
              以更灵活的交易条件参与全球 ETF 市场，享受超低成本、股息分配、双向交易和杠杆优势
            </h3>
          </div>

          <div class="etf-efficient__grid">
            <div class="etf-efficient__row etf-efficient__row--3 scroll-fade-up">
              <div class="etf-efficient__card etf-efficient__card--sm ">
                <img class="etf-efficient__icon" src="@/assets/image/trading-product/etf/container2Icon1.png" alt="" />
                <div class="etf-efficient__cardTitle">支持多空双向交易</div>
                <div class="etf-efficient__cardDesc">一键做多做空，更灵活应对不同市场方向</div>
              </div>

              <div class="etf-efficient__card etf-efficient__card--sm ">
                <img class="etf-efficient__icon" src="@/assets/image/trading-product/etf/container2Icon2.png" alt="" />
                <div class="etf-efficient__cardTitle">无购买份额限制</div>
                <div class="etf-efficient__cardDesc">不受传统 ETF 份额购买门槛限制，以更灵活的方式参与交易</div>
              </div>

              <div class="etf-efficient__card etf-efficient__card--sm ">
                <img class="etf-efficient__icon" src="@/assets/image/trading-product/etf/container2Icon3.png" alt="" />
                <div class="etf-efficient__cardTitle">无买卖溢价</div>
                <div class="etf-efficient__cardDesc">直接跟踪标的ETF的实时价格，减少实际买入ETF份额时产生的溢价</div>
              </div>
            </div>

            <div class="etf-efficient__row etf-efficient__row--2 scroll-fade-up">
              <div class="etf-efficient__card etf-efficient__card--lg ">
                <div class="etf-efficient__media">
                  <div class="etf-efficient__mediaInner">
                    <img src="@/assets/image/trading-product/etf/container2Icon4.png" alt="" />
                  </div>
                </div>
                <div class="etf-efficient__cardBody">
                  <div class="etf-efficient__cardTitle">享有股息分配</div>
                  <div class="etf-efficient__cardDesc">持仓期间标的产生的股息，按规则享有相应股息调整</div>
                </div>
              </div>

              <div class="etf-efficient__card etf-efficient__card--lg ">
                <div class="etf-efficient__media">
                  <div class="etf-efficient__mediaInner">
                    <img src="@/assets/image/trading-product/etf/container2Icon5.png" alt="" />
                  </div>
                </div>
                <div class="etf-efficient__cardBody">
                  <div class="etf-efficient__cardTitle">无管理费和封闭期</div>
                  <div class="etf-efficient__cardDesc">无传统基金管理费与封闭期限制，更低成本，随时随地买卖资产</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="etf-follow">
        <div class="contentBox etf-follow__inner">
          <div class="etf-follow__header scroll-fade-up">
            <h2 class="title-48_bold md-title-24_bold">跟随全球资产增长主线</h2>
            <h3 class="subtitle-20_regular md-footnote-regular_12">基于全球市场热点、行业板块、历史表现、波动风格，精选最具潜力的 ETF 标的</h3>
          </div>

          <div class="etf-follow__tabs scroll-fade-up" aria-label="ETF 分类">
            <button class="etf-follow__tab is-active" type="button" data-tab="core">核心指数</button>
            <button class="etf-follow__tab" type="button" data-tab="hot">热门板块</button>
            <button class="etf-follow__tab" type="button" data-tab="history">历史表现</button>
            <button class="etf-follow__tab" type="button" data-tab="volatility">波动风格</button>
          </div>

          <div class="etf-follow__panels">
            <div class="etf-follow__panel is-active" data-panel="core">
              <div class="etf-follow__grid">
                <div class="etf-follow__card etf-follow__card--solid scroll-fade-up" data-group="sp500">
                  <div class="etf-follow__cardHead">
                    <div class="etf-follow__cardTitle">标普 500 ETF</div>
                    <div class="etf-follow__cardDesc">追踪美国大盘核心宽基，观察美国经济与龙头公司整体走势。</div>
                  </div>

                  <div class="etf-follow__divider"></div>

                  <div class="etf-follow__cardBody">
                    <div class="etf-follow__symbolTabs" role="tablist" aria-label="标普500ETF 标的">
                      <button class="etf-follow__symbolTab is-active" type="button" role="tab" aria-selected="true"
                        data-symbol="SPY">SPY</button>
                      <button class="etf-follow__symbolTab" type="button" role="tab" aria-selected="false"
                        data-symbol="VOO">VOO</button>
                      <button class="etf-follow__symbolTab" type="button" role="tab" aria-selected="false"
                        data-symbol="IVV">IVV</button>
                    </div>

                    <div class="etf-follow__meta">
                      <div class="etf-follow__metaItem">
                        <div class="etf-follow__metaLabel">发行商</div>
                        <div class="etf-follow__metaValue" data-meta="issuer">--</div>
                      </div>
                      <div class="etf-follow__metaItem">
                        <div class="etf-follow__metaLabel">成立时间</div>
                        <div class="etf-follow__metaValue" data-meta="year">--</div>
                      </div>
                      <div class="etf-follow__metaItem">
                        <div class="etf-follow__metaLabel">管理规模 (亿美元）</div>
                        <div class="etf-follow__metaValue" data-meta="aum">--</div>
                      </div>
                    </div>

                    <div class="etf-follow__perf" aria-label="收益率">
                      <div class="etf-follow__perfItem is-active" data-period="1y">
                        <div class="etf-follow__perfLabel">1年</div>
                        <div class="etf-follow__perfValue" data-value="1y">--</div>
                      </div>
                      <div class="etf-follow__perfItem" data-period="3y">
                        <div class="etf-follow__perfLabel">3年</div>
                        <div class="etf-follow__perfValue" data-value="3y">--</div>
                      </div>
                      <div class="etf-follow__perfItem" data-period="5y">
                        <div class="etf-follow__perfLabel">5年</div>
                        <div class="etf-follow__perfValue" data-value="5y">--</div>
                      </div>
                      <div class="etf-follow__perfItem" data-period="10y">
                        <div class="etf-follow__perfLabel">10年</div>
                        <div class="etf-follow__perfValue" data-value="10y">--</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="etf-follow__card etf-follow__card--glass scroll-fade-up" data-group="nas100">
                  <div class="etf-follow__cardHead">
                    <div class="etf-follow__cardTitle">纳指 100 ETF</div>
                    <div class="etf-follow__cardDesc">聚焦大型科技与成长公司，是观察全球创新产业风向的重要入口。</div>
                  </div>

                  <div class="etf-follow__divider"></div>

                  <div class="etf-follow__cardBody">
                    <div class="etf-follow__symbolTabs" role="tablist" aria-label="纳指100ETF 标的">
                      <button class="etf-follow__symbolTab is-active" type="button" role="tab" aria-selected="true"
                        data-symbol="QQQ">QQQ</button>
                      <button class="etf-follow__symbolTab" type="button" role="tab" aria-selected="false"
                        data-symbol="TQQQ">TQQQ</button>
                    </div>

                    <div class="etf-follow__meta">
                      <div class="etf-follow__metaItem">
                        <div class="etf-follow__metaLabel">发行商</div>
                        <div class="etf-follow__metaValue" data-meta="issuer">--</div>
                      </div>
                      <div class="etf-follow__metaItem">
                        <div class="etf-follow__metaLabel">成立时间</div>
                        <div class="etf-follow__metaValue" data-meta="year">--</div>
                      </div>
                      <div class="etf-follow__metaItem">
                        <div class="etf-follow__metaLabel">管理规模 (亿美元）</div>
                        <div class="etf-follow__metaValue" data-meta="aum">--</div>
                      </div>
                    </div>

                    <div class="etf-follow__perf" aria-label="收益率">
                      <div class="etf-follow__perfItem is-active" data-period="1y">
                        <div class="etf-follow__perfLabel">1年</div>
                        <div class="etf-follow__perfValue" data-value="1y">--</div>
                      </div>
                      <div class="etf-follow__perfItem" data-period="3y">
                        <div class="etf-follow__perfLabel">3年</div>
                        <div class="etf-follow__perfValue" data-value="3y">--</div>
                      </div>
                      <div class="etf-follow__perfItem" data-period="5y">
                        <div class="etf-follow__perfLabel">5年</div>
                        <div class="etf-follow__perfValue" data-value="5y">--</div>
                      </div>
                      <div class="etf-follow__perfItem" data-period="10y">
                        <div class="etf-follow__perfLabel">10年</div>
                        <div class="etf-follow__perfValue" data-value="10y">--</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="etf-follow__panel" data-panel="hot">
              <div class="etf-follow__hotRows">
                <div class="etf-follow__hotRow">
                  <div class="etf-follow__hotCard etf-follow__hotCard--solid etf-follow__hotCard--lg scroll-fade-up">
                    <div class="etf-follow__hotHead">
                      <div class="etf-follow__hotTitle">大盘</div>
                      <div class="etf-follow__hotDesc">追踪标普 500、纳指 100 等核心宽基，把握美股整体节奏。</div>
                    </div>
                    <div class="etf-follow__pillGroup">
                      <span class="etf-follow__pill etf-follow__pill--light">SPY</span>
                      <span class="etf-follow__pill etf-follow__pill--light">QQQ</span>
                      <span class="etf-follow__pill etf-follow__pill--light">DIA</span>
                    </div>
                    <img class="etf-follow__hotArt etf-follow__hotArt--sp"
                      src="@/assets/image/trading-product/etf/section3Tab2Icon1.png" alt="" />
                  </div>

                  <div class="etf-follow__hotCard etf-follow__hotCard--glass etf-follow__hotCard--sm scroll-fade-up">
                    <div class="etf-follow__hotHead">
                      <div class="etf-follow__hotTitle">科技</div>
                      <div class="etf-follow__hotDesc">聚焦软件、云计算与成长龙头，观察创新产业资金风向。</div>
                    </div>
                    <div class="etf-follow__pillGroup">
                      <span class="etf-follow__pill">XLK</span>
                    </div>
                  </div>

                  <div class="etf-follow__hotCard etf-follow__hotCard--glass etf-follow__hotCard--sm scroll-fade-up">
                    <div class="etf-follow__hotHead">
                      <div class="etf-follow__hotTitle">半导体</div>
                      <div class="etf-follow__hotDesc">覆盖芯片设计、制程与 AI 算力产业链高弹性主题。</div>
                    </div>
                    <div class="etf-follow__pillGroup">
                      <span class="etf-follow__pill">SMH</span>
                      <span class="etf-follow__pill">SOXX</span>
                    </div>
                  </div>
                </div>

                <div class="etf-follow__hotRow">
                  <div class="etf-follow__hotCard etf-follow__hotCard--glass etf-follow__hotCard--sm scroll-fade-up">
                    <div class="etf-follow__hotHead">
                      <div class="etf-follow__hotTitle">黄金</div>
                      <div class="etf-follow__hotDesc">实物黄金与矿业主题，常用于对冲宏观与地缘不确定性。</div>
                    </div>
                    <div class="etf-follow__pillGroup">
                      <span class="etf-follow__pill">GLD</span>
                    </div>
                  </div>

                  <div class="etf-follow__hotCard etf-follow__hotCard--glass etf-follow__hotCard--sm scroll-fade-up">
                    <div class="etf-follow__hotHead">
                      <div class="etf-follow__hotTitle">债券</div>
                      <div class="etf-follow__hotDesc">国债与企业债 ETF，在利率周期中提供分散与稳健配置。</div>
                    </div>
                    <div class="etf-follow__pillGroup">
                      <span class="etf-follow__pill">AGG</span>
                      <span class="etf-follow__pill">TLT</span>
                    </div>
                  </div>

                  <div class="etf-follow__hotCard etf-follow__hotCard--glass etf-follow__hotCard--lg scroll-fade-up">
                    <div class="etf-follow__hotHead">
                      <div class="etf-follow__hotTitle">新兴市场</div>
                      <div class="etf-follow__hotDesc">布局全球成长经济体，分散单一市场集中度风险。</div>
                    </div>
                    <div class="etf-follow__pillGroup">
                      <span class="etf-follow__pill">EEM</span>
                      <span class="etf-follow__pill">VWO</span>
                    </div>
                    <img class="etf-follow__hotArt etf-follow__hotArt--em"
                      src="@/assets/image/trading-product/etf/section3Tab2Icon2.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div class="etf-follow__panel" data-panel="history">
              <div class="etf-follow__historyBox scroll-fade-up">
                <button class="etf-follow__historySelect" type="button" aria-haspopup="listbox" aria-expanded="false">
                  <span class="etf-follow__historySelectText">历史总收益率</span>
                  <span class="etf-follow__historySelectArrow"></span>
                </button>

                <div class="etf-follow__historyMenu" role="listbox" aria-label="收益维度" hidden>
                  <button class="etf-follow__historyOption" type="button" role="option"
                    data-metric="total_return">历史总收益率</button>
                  <button class="etf-follow__historyOption" type="button" role="option" data-metric="10y">过去10年</button>
                  <button class="etf-follow__historyOption" type="button" role="option" data-metric="5y">过去5年</button>
                  <button class="etf-follow__historyOption" type="button" role="option" data-metric="3y">过去3年</button>
                  <button class="etf-follow__historyOption" type="button" role="option" data-metric="1y">过去1年</button>
                </div>

                <div class="etf-follow__historyTop1">
                  <div class="etf-follow__historyTop1Left">
                    <img class="etf-follow__historyMedal" src="@/assets/image/trading-product/etf/section3Tab3Icon1.png"
                      alt="" />
                    <div class="etf-follow__historyTop1Info">
                      <div class="etf-follow__historyTop1Symbol">--</div>
                      <div class="etf-follow__historyTop1Desc">--</div>
                    </div>
                  </div>
                  <div class="etf-follow__historyTop1Value">--</div>
                </div>

                <div class="etf-follow__historyRank">
                  <div class="etf-follow__historyTitle">历史表现排名</div>
                  <div class="etf-follow__historyHeader">
                    <div class="etf-follow__historyCol etf-follow__historyCol--rank">排名</div>
                    <div class="etf-follow__historyCol etf-follow__historyCol--symbol">产品代码</div>
                    <div class="etf-follow__historyCol etf-follow__historyCol--desc">产品名称</div>
                    <div class="etf-follow__historyCol etf-follow__historyCol--ret">收益率</div>
                  </div>
                  <div class="etf-follow__historyDivider"></div>
                  <div class="etf-follow__historyList"></div>
                  <div class="etf-follow__historyDivider"></div>
                </div>
              </div>
            </div>

            <div class="etf-follow__panel" data-panel="volatility">
              <div class="etf-follow__volBox scroll-fade-up">
                <div class="etf-follow__volTabs" role="tablist" aria-label="波动风格分类">
                  <button class="etf-follow__volTab is-active" type="button" role="tab" aria-selected="true"
                    data-style="sync" data-desc="波动通常接近市场大盘，适合观察整体市场方向。">市场同步型 β ≈ 1</button>
                  <button class="etf-follow__volTab" type="button" role="tab" aria-selected="false" data-style="trend"
                    data-desc="波动通常高于市场大盘，更适合观察强趋势与高弹性主题。">趋势放大型 β &gt; 1</button>
                  <button class="etf-follow__volTab" type="button" role="tab" aria-selected="false" data-style="low"
                    data-desc="波动通常低于市场大盘，适合观察相对稳健或低波动资产方向。">低波防御型 0 &lt; β &lt; 1</button>
                  <button class="etf-follow__volTab" type="button" role="tab" aria-selected="false" data-style="inverse"
                    data-desc="波动方向可能与市场大盘相反，适合观察特殊策略或反向资产表现。">反向特殊型 β &lt; 0</button>
                </div>

                <div class="etf-follow__volContent">
                  <div class="etf-follow__volHead">
                    <div class="etf-follow__volTitle">--</div>
                    <div class="etf-follow__volDesc">--</div>
                  </div>

                  <div class="etf-follow__volDivider"></div>

                  <div class="etf-follow__volSection">
                    <div class="etf-follow__volSectionTitle">关联 ETF 产品</div>
                    <div class="etf-follow__volList"></div>
                  </div>

                  <div class="etf-follow__volDivider"></div>

                  <div class="etf-follow__volHelp">
                    <div class="etf-follow__volHelpTitle">β 值如何理解风险？</div>
                    <div class="etf-follow__volHelpText">
                      <div>β 值用于衡量 ETF 相对市场大盘的波动敏感度，通常通过 ETF 与市场基准的历史收益变化计算。简单理解，当市场波动 1% 时，β 值可帮助观察该 ETF 过去通常会跟随波动多少。
                      </div>
                      <div>β 值基于历史数据，仅用于理解系统性风险和波动风格，不代表未来表现。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="etf-follow__note scroll-fade-up">
              数据来源：TradingView / 公开市场数据整理，历史表现仅供参考，不代表未来结果。
            </div>
          </div>
        </div>
      </section>
      <section class="etf-giants">
        <div class="contentBox etf-giants__inner">
          <div class="etf-giants__header scroll-fade-up">
            <h2 class="title-48_bold md-title-24_bold">接入全球 ETF 巨头的核心产品</h2>
            <h3 class="subtitle-20_regular md-footnote-regular_12">
              从 BlackRock、Vanguard 到 State street、Invseco，EBC 覆盖全球五大顶级ETF 发行商旗舰产品，帮助交易者快速进入宽基指数、科技成长、半导体、黄金矿业等核心市场。
            </h3>
          </div>

          <div class="etf-giants__grid scroll-fade-up">
            <div class="etf-giants__card etf-giants__card--black ">
              <div class="etf-giants__top">
                <div class="etf-giants__topRow">
                  <div class="etf-giants__logoBox">
                    <img class="etf-giants__logo" src="@/assets/image/trading-product/etf/container4Icon1.png" alt="" />
                  </div>
                  <div class="etf-giants__topName">贝莱德</div>
                </div>
                <div class="etf-giants__topDesc">万亿级资管巨头，以 iShares 构建全球 ETF 配置入口</div>
              </div>

              <div class="etf-giants__meta">
                <div class="etf-giants__stats">
                  <div class="etf-giants__statsLabels">
                    <div>成立时间</div>
                    <div>管理规模</div>
                  </div>
                  <div class="etf-giants__statsValues">
                    <div>1988年</div>
                    <div>超10万亿美元</div>
                  </div>
                </div>
              </div>

              <div class="etf-giants__featured">
                <div class="etf-giants__featuredTag">明星产品表现</div>
                <div class="etf-giants__ticker">SOXX</div>
                <div class="etf-giants__featuredRow">
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">过去1年</div>
                    <div class="etf-giants__metricValue etf-giants__metricValue--up">+139.19%</div>
                  </div>
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">ETF 规模（亿美元）</div>
                    <div class="etf-giants__metricValue">300</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="etf-giants__card etf-giants__card--red ">
              <div class="etf-giants__top">
                <div class="etf-giants__topRow">
                  <div class="etf-giants__logoBox">
                    <img class="etf-giants__logo" src="@/assets/image/trading-product/etf/container4Icon2.png" alt="" />
                  </div>
                  <div class="etf-giants__topName">先锋领航</div>
                </div>
                <div class="etf-giants__topDesc">被动投资先驱，以低成本指数产品服务全球长期投资者</div>
              </div>

              <div class="etf-giants__meta">
                <div class="etf-giants__stats">
                  <div class="etf-giants__statsLabels">
                    <div>成立时间</div>
                    <div>管理规模</div>
                  </div>
                  <div class="etf-giants__statsValues">
                    <div>1975年</div>
                    <div>超8万亿美元</div>
                  </div>
                </div>
              </div>

              <div class="etf-giants__featured">
                <div class="etf-giants__featuredTag">明星产品表现</div>
                <div class="etf-giants__ticker">VOO</div>
                <div class="etf-giants__featuredRow">
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">过去1年</div>
                    <div class="etf-giants__metricValue etf-giants__metricValue--up">+29.1%</div>
                  </div>
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">ETF 规模（亿美元）</div>
                    <div class="etf-giants__metricValue">9179</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="etf-giants__card etf-giants__card--blue ">
              <div class="etf-giants__top">
                <div class="etf-giants__topRow">
                  <div class="etf-giants__logoBox">
                    <img class="etf-giants__logo" src="@/assets/image/trading-product/etf/container4Icon3.png" alt="" />
                  </div>
                  <div class="etf-giants__topName">道富环球</div>
                </div>
                <div class="etf-giants__topDesc">ETF 行业开创者，以 SPDR 打造全球核心指数代表产品</div>
              </div>

              <div class="etf-giants__meta">
                <div class="etf-giants__stats">
                  <div class="etf-giants__statsLabels">
                    <div>成立时间</div>
                    <div>管理规模</div>
                  </div>
                  <div class="etf-giants__statsValues">
                    <div>1993年</div>
                    <div>超3万亿美元</div>
                  </div>
                </div>
              </div>

              <div class="etf-giants__featured">
                <div class="etf-giants__featuredTag">明星产品表现</div>
                <div class="etf-giants__ticker">SPY</div>
                <div class="etf-giants__featuredRow">
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">过去1年</div>
                    <div class="etf-giants__metricValue etf-giants__metricValue--up">+29.0%</div>
                  </div>
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">ETF 规模（亿美元）</div>
                    <div class="etf-giants__metricValue">7234</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="etf-giants__card etf-giants__card--indigo ">
              <div class="etf-giants__top">
                <div class="etf-giants__topRow">
                  <div class="etf-giants__logoBox">
                    <img class="etf-giants__logo" src="@/assets/image/trading-product/etf/container4Icon4.png" alt="" />
                  </div>
                  <div class="etf-giants__topName">景顺</div>
                </div>
                <div class="etf-giants__topDesc">全球投资管理巨头，以 QQQ 连接纳指 100 科技成长主线</div>
              </div>

              <div class="etf-giants__meta">
                <div class="etf-giants__stats">
                  <div class="etf-giants__statsLabels">
                    <div>成立时间</div>
                    <div>管理规模</div>
                  </div>
                  <div class="etf-giants__statsValues">
                    <div>1999年</div>
                    <div>超1.5万亿美元</div>
                  </div>
                </div>
              </div>

              <div class="etf-giants__featured">
                <div class="etf-giants__featuredTag">明星产品表现</div>
                <div class="etf-giants__ticker">QQQ</div>
                <div class="etf-giants__featuredRow">
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">过去1年</div>
                    <div class="etf-giants__metricValue etf-giants__metricValue--up">+39.1%</div>
                  </div>
                  <div class="etf-giants__metric">
                    <div class="etf-giants__metricLabel">ETF 规模（亿美元）</div>
                    <div class="etf-giants__metricValue">4327</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="container2">
        <div class="contentBox container2Content">
          <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up">交易 100+ ETF 实时报价</h2>
          <div class="shareTradingHours body-16_regular md-body-14_regular scroll-fade-up">
          <div class="shareTradingHours-label">
            <img src="@/assets/image/trading-product/share-cfds/section4Logo.png" alt="" loading="lazy" />
            <span>交易时间</span>
          </div>
          <span class="shareTradingHours-divider"></span>
          <div class="shareTradingHours-text">
            <div><strong>平台时间（UTC+3）：</strong><span>周一至周五 16:31 - 22:59</span></div>
            <div><strong>每日休市：</strong><span>22:59 - 次日 16:31 · 以 MT 平台显示为准</span></div>
          </div>
        </div>
          <div id="pageOverLay"></div>
          <product-module-new />
          <a :href="signupUrl" target="_blank" class="primary-default_large tableBtn">
            立即交易
          </a>
        </div>
      </section>
      <open-account openAccountTitle="开始交易 ETF CFD"></open-account>
      <section class="container4 commonQuestion">
        <div class="contentBox">
          <h2 class="scroll-fade-up">ETF差价合约相关问题</h2>
          <div class="QA-list">
            <div class="QA-item">
              <div class="QA-title">1、ETF是什么？</div>
              <div class="QA-content">
                <p class="QA-li">
                  ETF全称是“交易型开放式指数基金”，简单说就是‌把一堆股票打包成一个套餐，放在股市里买卖‌。比如你想买科技股但不会选，买科技ETF就等于同时持有苹果、微软等一堆科技公司股票。
                </p>
              </div>
            </div>
            <div class="QA-item">
              <div class="QA-title">2、ETF CFD 和传统 ETF 有什么区别？</div>
              <div class="QA-content">
                <p class="QA-li">
                  ETF CFD 是差价合约交易，不涉及实物资产交割，无需开户证券账户，也无需持有ETF份额；更适合短线、双向、杠杆交易策略。
                </p>
              </div>
            </div>
            <div class="QA-item">
              <div class="QA-title">3、是否需要实际购买ETF才能交易？</div>
              <div class="QA-content">
                <p class="QA-li">
                  不需要。通过EBC提供的ETF CFD产品，您无需持有ETF即可交易ETF价格波动，所有操作均在交易平台内完成。
                </p>
              </div>
            </div>

            <div class="QA-item">
              <div class="QA-title">4、交易ETF CFD的成本有哪些？</div>
              <div class="QA-content">
                <p class="QA-li">
                  ETF CFD 的主要交易成本包括点差和隔夜利息费，整体持有成本低于传统ETF管理费+交易佣金的费率结构（具体因产品、持仓方向和市场条件而异，最终以交易平台显示为准）
                </p>
              </div>
            </div>
            <div class="QA-item">
              <div class="QA-title">5、ETF CFD 可以做空吗？</div>
              <div class="QA-content">
                <p class="QA-li">
                  可以。与传统ETF只能做多不同，ETF CFD支持看空交易，适合震荡市或下跌行情下的策略部署。
                </p>
              </div>
            </div>
            <div class="QA-item">
              <div class="QA-title">6、ETF CFD 适合新手交易者吗？</div>
              <div class="QA-content">
                <p class="QA-li">
                  CFD产品具有杠杆属性，适合有一定风险意识和交易经验的用户。我们建议新手通过模拟账户熟悉产品机制后再进行实盘交易。
                </p>
              </div>
            </div>
            <div class="QA-item">
              <div class="QA-title">7、β值在ETF选择中有什么作用？</div>
              <div class="QA-content">
                <div class="QA-li">
                  β衡量ETF相对市场基准的历史波动敏感度，可以简单理解为，当整个市场出现波动时，某个ETF同步波动的程度。<br>
                  如果β=1，与市场同步波动，可追踪整体市场走势，如SPY、VO0等宽基ETF；<br>
                  如果β＞1，波动大于大盘，在市场上涨时有望放大收益，被视作是进攻性资产，比如SMH、QQQ，通常是具有较强的成长性或者热门赛道。但需注意，β值过高是一把双刃剑，当大盘下跌时，高β值资产往往跑输市场，参与时需要平衡收益与风险。<br>
                  如果0&lt;β&lt;1，波动小于大盘，属于防御性资产，如 XLU、XLV。虽然上涨时难以跑赢大盘，但下跌时回撤通常更小，适当配置有助于增强组合抗风险能力；<br>
                  如果β＜0，通常是反向或者特殊性资产，其方向与市场相反，如TLT、部分反向ETF。<br>
                  β基于历史数据计算，仅用于理解波动风格，不代表未来表现。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <message-v3-etf></message-v3-etf>

    <page-footer></page-footer>
  </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
  mapGetters,
} from 'vuex'
export default {
  mixins: [fadeAnimate],
  data() {
    return {
      infoData: "",
      newData: "",
      pagIndex: 0,
      num: 3,
      newsdisplay: "none"
    }
  },
  computed: {
    ...mapGetters([
      'signupUrl',
    ]),
  },
  destroyed() {
  },

  mounted() {
    this.initPage()
    this.initEtfPage()
  },
  methods: {
    initEtfPage() {
      const etfData = [
        {
          "symbol": "AGG",
          "symbolEn": "iShares Core US Aggregate Bond ETF",
          "symbolZh": "美国全债市ETF-iShares",
          "symbolFan": "美國全債市ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "1380.26",
          "returns": {
            "total_return": "-3.32%",
            "10y": "-11.85%",
            "5y": "-14.29%",
            "3y": "0.93%",
            "1y": "0.67%"
          },
          "betas": {
            "beta_5y": "0.25%",
            "beta_3y": "0.21%",
            "beta_1y": "0.11%"
          }
        },
        {
          "symbol": "BIL",
          "symbolEn": "SPDR Bloomberg Barclays 1-3 Month T-Bill ETF",
          "symbolZh": "1-3月美国国债ETF-SPDR",
          "symbolFan": "1-3月美國國債ETF-SPDR",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "468.29",
          "returns": {
            "total_return": "-0.05%",
            "10y": "0.12%",
            "5y": "0.07%",
            "3y": "-0.13%",
            "1y": "-0.07%"
          },
          "betas": {
            "beta_5y": "0.00%",
            "beta_3y": "0.00%",
            "beta_1y": "0.01%"
          }
        },
        {
          "symbol": "BSV",
          "symbolEn": "Vanguard Short-Term Bond Index Fund",
          "symbolZh": "美国短期债券ETF-Vanguard",
          "symbolFan": "美國短期債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "444.80",
          "returns": {
            "total_return": "3.60%",
            "10y": "-4.00%",
            "5y": "-5.41%",
            "3y": "3.03%",
            "1y": "-0.60%"
          },
          "betas": {
            "beta_5y": "0.09%",
            "beta_3y": "0.05%",
            "beta_1y": "0.05%"
          }
        },
        {
          "symbol": "DGRO",
          "symbolEn": "iShares Core Dividend Growth ETF",
          "symbolZh": "安硕核心股利增长ETF",
          "symbolFan": "安碩核心股利增長ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "409.31",
          "returns": {
            "total_return": "202.38%",
            "10y": "178.98%",
            "5y": "51.80%",
            "3y": "45.91%",
            "1y": "19.91%"
          },
          "betas": {
            "beta_5y": "0.78%",
            "beta_3y": "0.71%",
            "beta_1y": "0.59%"
          }
        },
        {
          "symbol": "DIA",
          "symbolEn": "SPDR Dow Jones Industrial Average ETF Trust",
          "symbolZh": "道琼斯指数ETF-SPDR",
          "symbolFan": "道瓊斯指數ETF-SPDR",
          "tick": [],
          "focus": "大盘",
          "fundSize": "457.94",
          "returns": {
            "total_return": "563.52%",
            "10y": "191.45%",
            "5y": "54.42%",
            "3y": "52.05%",
            "1y": "21.64%"
          },
          "betas": {
            "beta_5y": "0.87%",
            "beta_3y": "0.85%",
            "beta_1y": "0.84%"
          }
        },
        {
          "symbol": "EEM",
          "symbolEn": "iShares MSCI Emerging Markets ETF (USD)",
          "symbolZh": "新兴市场ETF-iShares",
          "symbolFan": "新興市場ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "308.21",
          "returns": {
            "total_return": "516.31%",
            "10y": "106.26%",
            "5y": "26.08%",
            "3y": "67.46%",
            "1y": "46.15%"
          },
          "betas": {
            "beta_5y": "0.73%",
            "beta_3y": "0.80%",
            "beta_1y": "1.29%"
          }
        },
        {
          "symbol": "EFA",
          "symbolEn": "iShares MSCI EAFE ETF (USD)",
          "symbolZh": "欧澳远东指数ETF-iShares",
          "symbolFan": "歐澳遠東指數ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "779.08",
          "returns": {
            "total_return": "147.10%",
            "10y": "84.99%",
            "5y": "31.82%",
            "3y": "41.10%",
            "1y": "18.38%"
          },
          "betas": {
            "beta_5y": "0.77%",
            "beta_3y": "0.61%",
            "beta_1y": "0.97%"
          }
        },
        {
          "symbol": "EWT",
          "symbolEn": "iShares MSCI TAIWAN ETF",
          "symbolZh": "安硕MSCI台湾ETF",
          "symbolFan": "安碩MSCI台灣ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "110.26",
          "returns": {
            "total_return": "171.25%",
            "10y": "285.02%",
            "5y": "67.53%",
            "3y": "117.85%",
            "1y": "87.60%"
          },
          "betas": {
            "beta_5y": "1.16%",
            "beta_3y": "1.26%",
            "beta_1y": "1.50%"
          }
        },
        {
          "symbol": "EWW",
          "symbolEn": "iShares MSCI Mexico ETF",
          "symbolZh": "墨西哥投资指数ETF-iShares MSCI",
          "symbolFan": "墨西哥投資指數ETF-iShares MSCI",
          "tick": [],
          "focus": "总市场",
          "fundSize": "19.49",
          "returns": {
            "total_return": "645.16%",
            "10y": "59.17%",
            "5y": "65.44%",
            "3y": "20.92%",
            "1y": "30.37%"
          },
          "betas": {
            "beta_5y": "0.78%",
            "beta_3y": "0.60%",
            "beta_1y": "0.94%"
          }
        },
        {
          "symbol": "EWY",
          "symbolEn": "iShares MSCI SOUTH KOREA ETF",
          "symbolZh": "韩国ETF-iShares MSCI",
          "symbolFan": "韓國ETF-iShares MSCI",
          "tick": [],
          "focus": "总市场",
          "fundSize": "250.43",
          "returns": {
            "total_return": "944.99%",
            "10y": "304.74%",
            "5y": "124.03%",
            "3y": "207.06%",
            "1y": "203.51%"
          },
          "betas": {
            "beta_5y": "1.46%",
            "beta_3y": "1.74%",
            "beta_1y": "2.22%"
          }
        },
        {
          "symbol": "EWZ",
          "symbolEn": "iShares MSCI BRAZIL ETF",
          "symbolZh": "巴西ETF-iShares",
          "symbolFan": "巴西ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "92.23",
          "returns": {
            "total_return": "81.92%",
            "10y": "24.22%",
            "5y": "-16.15%",
            "3y": "5.73%",
            "1y": "20.53%"
          },
          "betas": {
            "beta_5y": "0.64%",
            "beta_3y": "0.45%",
            "beta_1y": "0.88%"
          }
        },
        {
          "symbol": "FVD",
          "symbolEn": "First Trust Value Line Dividend Index Fund",
          "symbolZh": "第一信托超值系列红利指数基金",
          "symbolFan": "第一信託超值系列紅利指數基金",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "80.56",
          "returns": {
            "total_return": "217.53%",
            "10y": "80.35%",
            "5y": "19.91%",
            "3y": "19.33%",
            "1y": "6.96%"
          },
          "betas": {
            "beta_5y": "0.65%",
            "beta_3y": "0.53%",
            "beta_1y": "0.36%"
          }
        },
        {
          "symbol": "FXI",
          "symbolEn": "iShares CHINA LARGE-CAP ETF",
          "symbolZh": "中国大盘股ETF-iShares",
          "symbolFan": "中國大盤股ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "51.90",
          "returns": {
            "total_return": "87.99%",
            "10y": "2.59%",
            "5y": "-26.29%",
            "3y": "17.37%",
            "1y": "-7.81%"
          },
          "betas": {
            "beta_5y": "0.30%",
            "beta_3y": "0.29%",
            "beta_1y": "0.95%"
          }
        },
        {
          "symbol": "GDX",
          "symbolEn": "VanEck Vectors Gold Miners ETF",
          "symbolZh": "黄金矿业ETF-VanEck",
          "symbolFan": "黃金礦業ETF-VanEck",
          "tick": [],
          "focus": "材料",
          "fundSize": "259.32",
          "returns": {
            "total_return": "131.00%",
            "10y": "225.09%",
            "5y": "142.14%",
            "3y": "177.65%",
            "1y": "56.83%"
          },
          "betas": {
            "beta_5y": "0.61%",
            "beta_3y": "0.18%",
            "beta_1y": "1.63%"
          }
        },
        {
          "symbol": "GDXJ",
          "symbolEn": "VanEck Junior Gold Miners ETF",
          "symbolZh": "小型黄金矿业ETF-VanEck",
          "symbolFan": "小型黃金礦業ETF-VanEck",
          "tick": [],
          "focus": "材料",
          "fundSize": "81.39",
          "returns": {
            "total_return": "5.57%",
            "10y": "171.56%",
            "5y": "125.03%",
            "3y": "207.65%",
            "1y": "56.85%"
          },
          "betas": {
            "beta_5y": "0.80%",
            "beta_3y": "0.29%",
            "beta_1y": "1.93%"
          }
        },
        {
          "symbol": "GLD",
          "symbolEn": "SPDR Gold Shares ETF",
          "symbolZh": "黄金ETF-SPDR",
          "symbolFan": "黃金ETF-SPDR",
          "tick": [],
          "focus": "黄金",
          "fundSize": "1411.97",
          "returns": {
            "total_return": "774.63%",
            "10y": "215.27%",
            "5y": "133.90%",
            "3y": "118.96%",
            "1y": "24.29%"
          },
          "betas": {
            "beta_5y": "0.14%",
            "beta_3y": "-0.08%",
            "beta_1y": "0.53%"
          }
        },
        {
          "symbol": "HDV",
          "symbolEn": "iShares Core High Dividend ETF",
          "symbolZh": "iShares安硕核心高股息ETF",
          "symbolFan": "iShares安碩核心高股息ETF",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "135.43",
          "returns": {
            "total_return": "167.04%",
            "10y": "67.39%",
            "5y": "41.57%",
            "3y": "33.56%",
            "1y": "15.84%"
          },
          "betas": {
            "beta_5y": "0.55%",
            "beta_3y": "0.35%",
            "beta_1y": "0.06%"
          }
        },
        {
          "symbol": "HYG",
          "symbolEn": "iShares iBoxx $ High Yield Corporate Bond Fund",
          "symbolZh": "债券指数ETF-iShares iBoxx高收益公司债",
          "symbolFan": "債券指數ETF-iShares iBoxx高收益公司債",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "164.19",
          "returns": {
            "total_return": "-23.59%",
            "10y": "-4.04%",
            "5y": "-8.71%",
            "3y": "6.81%",
            "1y": "0.26%"
          },
          "betas": {
            "beta_5y": "0.40%",
            "beta_3y": "0.27%",
            "beta_1y": "0.23%"
          }
        },
        {
          "symbol": "IEMG",
          "symbolEn": "iShares Core MSCI Emerging Mkts ETF",
          "symbolZh": "核心MSCI新兴市场ETF-iShares",
          "symbolFan": "核心MSCI新興市場ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1635.76",
          "returns": {
            "total_return": "68.64%",
            "10y": "107.60%",
            "5y": "25.67%",
            "3y": "64.14%",
            "1y": "42.35%"
          },
          "betas": {
            "beta_5y": "0.73%",
            "beta_3y": "0.80%",
            "beta_1y": "1.27%"
          }
        },
        {
          "symbol": "IJH",
          "symbolEn": "iShares S&P Midcap 400 Index Fund",
          "symbolZh": "标普中型股指数ETF-iShares",
          "symbolFan": "標普中型股指數ETF-iShares",
          "tick": [],
          "focus": "中盘",
          "fundSize": "1221.63",
          "returns": {
            "total_return": "720.57%",
            "10y": "153.43%",
            "5y": "43.06%",
            "3y": "45.73%",
            "1y": "24.22%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.06%",
            "beta_1y": "0.85%"
          }
        },
        {
          "symbol": "IJR",
          "symbolEn": "iShares Core S&P Small-Cap ETF",
          "symbolZh": "标普小盘股指数ETF-iShares",
          "symbolFan": "標普小盤股指數ETF-iShares",
          "tick": [],
          "focus": "小盘",
          "fundSize": "1071.44",
          "returns": {
            "total_return": "778.34%",
            "10y": "143.10%",
            "5y": "27.26%",
            "3y": "42.59%",
            "1y": "32.63%"
          },
          "betas": {
            "beta_5y": "1.03%",
            "beta_3y": "1.15%",
            "beta_1y": "0.94%"
          }
        },
        {
          "symbol": "ITOT",
          "symbolEn": "iShares Trust S & P 1500",
          "symbolZh": "标普全美股市ETF-iShares",
          "symbolFan": "標普全美股市ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "936.23",
          "returns": {
            "total_return": "543.89%",
            "10y": "241.48%",
            "5y": "68.19%",
            "3y": "67.16%",
            "1y": "24.00%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.04%",
            "beta_1y": "1.01%"
          }
        },
        {
          "symbol": "IVE",
          "symbolEn": "iShares S&P 500 Value ETF",
          "symbolZh": "标普500价值指数ETF-iShares",
          "symbolFan": "標普500價值指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "478.75",
          "returns": {
            "total_return": "278.78%",
            "10y": "145.10%",
            "5y": "56.00%",
            "3y": "40.98%",
            "1y": "18.26%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.82%",
            "beta_1y": "0.68%"
          }
        },
        {
          "symbol": "IVV",
          "symbolEn": "iShares Core S&P 500 ETF (USD)",
          "symbolZh": "标普500ETF-iShares",
          "symbolFan": "標普500ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "8110.40",
          "returns": {
            "total_return": "420.56%",
            "10y": "254.77%",
            "5y": "77.25%",
            "3y": "68.17%",
            "1y": "23.50%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.01%",
            "beta_1y": "1.01%"
          }
        },
        {
          "symbol": "IVW",
          "symbolEn": "iShares S&P 500 Growth ETF",
          "symbolZh": "标普500成长股指数ETF-iShares",
          "symbolFan": "標普500成長股指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "753.92",
          "returns": {
            "total_return": "570.02%",
            "10y": "366.45%",
            "5y": "92.65%",
            "3y": "94.68%",
            "1y": "28.24%"
          },
          "betas": {
            "beta_5y": "1.18%",
            "beta_3y": "1.19%",
            "beta_1y": "1.28%"
          }
        },
        {
          "symbol": "IWB",
          "symbolEn": "iShares Russell 1000 ETF",
          "symbolZh": "罗素1000指数ETF-iShares",
          "symbolFan": "羅素1000指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "486.34",
          "returns": {
            "total_return": "435.87%",
            "10y": "249.10%",
            "5y": "71.12%",
            "3y": "67.34%",
            "1y": "22.88%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.02%",
            "beta_1y": "0.99%"
          }
        },
        {
          "symbol": "IWD",
          "symbolEn": "iShares Russell 1000 Value ETF",
          "symbolZh": "罗素1000价值指数ETF-iShares",
          "symbolFan": "羅素1000價值指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "771.62",
          "returns": {
            "total_return": "333.12%",
            "10y": "136.41%",
            "5y": "54.37%",
            "3y": "53.48%",
            "1y": "26.71%"
          },
          "betas": {
            "beta_5y": "0.85%",
            "beta_3y": "0.84%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "IWF",
          "symbolEn": "iShares Russell 1000 Growth ETF",
          "symbolZh": "罗素1000成长指数ETF-iShares",
          "symbolFan": "羅素1000成長指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "1281.73",
          "returns": {
            "total_return": "522.09%",
            "10y": "386.94%",
            "5y": "85.04%",
            "3y": "78.63%",
            "1y": "19.19%"
          },
          "betas": {
            "beta_5y": "1.17%",
            "beta_3y": "1.18%",
            "beta_1y": "1.25%"
          }
        },
        {
          "symbol": "IWM",
          "symbolEn": "iShares Russell 2000 ETF",
          "symbolZh": "罗素2000ETF-iShares",
          "symbolFan": "羅素2000ETF-iShares",
          "tick": [],
          "focus": "小盘",
          "fundSize": "824.68",
          "returns": {
            "total_return": "536.66%",
            "10y": "153.37%",
            "5y": "29.58%",
            "3y": "55.81%",
            "1y": "38.66%"
          },
          "betas": {
            "beta_5y": "1.12%",
            "beta_3y": "1.30%",
            "beta_1y": "1.12%"
          }
        },
        {
          "symbol": "IWN",
          "symbolEn": "iShares Russell 2000 Value ETF",
          "symbolZh": "罗素2000价值股指数ETF-iShares",
          "symbolFan": "羅素2000價值股指數ETF-iShares",
          "tick": [],
          "focus": "小盘",
          "fundSize": "142.81",
          "returns": {
            "total_return": "526.20%",
            "10y": "121.14%",
            "5y": "29.88%",
            "3y": "52.09%",
            "1y": "39.31%"
          },
          "betas": {
            "beta_5y": "1.03%",
            "beta_3y": "1.13%",
            "beta_1y": "0.97%"
          }
        },
        {
          "symbol": "IWS",
          "symbolEn": "iShares Russell Mid-Cap Value ETF",
          "symbolZh": "罗素中型价值股指数ETF-iShares",
          "symbolFan": "羅素中型價值股指數ETF-iShares",
          "tick": [],
          "focus": "中盘",
          "fundSize": "156.30",
          "returns": {
            "total_return": "532.73%",
            "10y": "120.74%",
            "5y": "43.43%",
            "3y": "48.80%",
            "1y": "25.26%"
          },
          "betas": {
            "beta_5y": "0.96%",
            "beta_3y": "0.97%",
            "beta_1y": "0.73%"
          }
        },
        {
          "symbol": "LQD",
          "symbolEn": "iShares iBoxx $ Investment Grade Corporate Bond ETF",
          "symbolZh": "债券指数ETF-iShares iBoxx投资级公司债",
          "symbolFan": "債券指數ETF-iShares iBoxx投資級公司債",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "309.50",
          "returns": {
            "total_return": "5.86%",
            "10y": "-10.17%",
            "5y": "-18.76%",
            "3y": "1.59%",
            "1y": "0.82%"
          },
          "betas": {
            "beta_5y": "0.44%",
            "beta_3y": "0.36%",
            "beta_1y": "0.20%"
          }
        },
        {
          "symbol": "MDY",
          "symbolEn": "SPDR S&P Midcap 400 ETF",
          "symbolZh": "标普中型股400指数ETF-SPDR",
          "symbolFan": "標普中型股400指數ETF-SPDR",
          "tick": [],
          "focus": "中盘",
          "fundSize": "272.47",
          "returns": {
            "total_return": "1721.40%",
            "10y": "155.07%",
            "5y": "43.27%",
            "3y": "45.62%",
            "1y": "24.09%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.05%",
            "beta_1y": "0.84%"
          }
        },
        {
          "symbol": "RSP",
          "symbolEn": "Invesco S&P 500 Eql Wght ETF",
          "symbolZh": "平均加权指数ETF-Rydex S&P",
          "symbolFan": "平均加權指數ETF-Rydex S&P",
          "tick": [],
          "focus": "大盘",
          "fundSize": "930.28",
          "returns": {
            "total_return": "719.97%",
            "10y": "162.85%",
            "5y": "41.32%",
            "3y": "42.62%",
            "1y": "17.20%"
          },
          "betas": {
            "beta_5y": "0.92%",
            "beta_3y": "0.90%",
            "beta_1y": "0.71%"
          }
        },
        {
          "symbol": "SCHB",
          "symbolEn": "Schwab US Broad Market ETF",
          "symbolZh": "嘉信美国整体市场ETF",
          "symbolFan": "嘉信美國整體市場ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "433.57",
          "returns": {
            "total_return": "587.84%",
            "10y": "243.51%",
            "5y": "68.62%",
            "3y": "69.17%",
            "1y": "23.85%"
          },
          "betas": {
            "beta_5y": "1.03%",
            "beta_3y": "1.04%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "SCHD",
          "symbolEn": "Schwab US Dividend Equity ETF",
          "symbolZh": "美国红利股ETF-Schwab",
          "symbolFan": "美國紅利股ETF-Schwab",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "970.20",
          "returns": {
            "total_return": "283.16%",
            "10y": "133.86%",
            "5y": "28.11%",
            "3y": "33.01%",
            "1y": "18.74%"
          },
          "betas": {
            "beta_5y": "0.69%",
            "beta_3y": "0.60%",
            "beta_1y": "0.36%"
          }
        },
        {
          "symbol": "SCHF",
          "symbolEn": "Schwab International Equity ETF",
          "symbolZh": "嘉信国际股票ETF",
          "symbolFan": "嘉信國際股票ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "669.55",
          "returns": {
            "total_return": "130.65%",
            "10y": "108.83%",
            "5y": "40.94%",
            "3y": "54.01%",
            "1y": "28.01%"
          },
          "betas": {
            "beta_5y": "0.82%",
            "beta_3y": "0.72%",
            "beta_1y": "1.04%"
          }
        },
        {
          "symbol": "SCHG",
          "symbolEn": "Schwab US Large-Cap Growth ETF",
          "symbolZh": "嘉信美国大盘股成长型ETF",
          "symbolFan": "嘉信美國大盤股成長型ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "596.50",
          "returns": {
            "total_return": "953.03%",
            "10y": "409.28%",
            "5y": "89.01%",
            "3y": "83.36%",
            "1y": "19.07%"
          },
          "betas": {
            "beta_5y": "1.20%",
            "beta_3y": "1.20%",
            "beta_1y": "1.27%"
          }
        },
        {
          "symbol": "SCHX",
          "symbolEn": "Schwab US Large-Cap ETF",
          "symbolZh": "嘉信理财美国大盘股ETF",
          "symbolFan": "嘉信理財美國大盤股ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "724.26",
          "returns": {
            "total_return": "620.15%",
            "10y": "253.60%",
            "5y": "72.42%",
            "3y": "70.01%",
            "1y": "22.91%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.02%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "SDY",
          "symbolEn": "SPDR S&P Dividend ETF",
          "symbolZh": "股息指数ETF-SPDR S&P",
          "symbolFan": "股息指數ETF-SPDR S&P",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "214.81",
          "returns": {
            "total_return": "177.11%",
            "10y": "83.68%",
            "5y": "23.75%",
            "3y": "24.05%",
            "1y": "11.49%"
          },
          "betas": {
            "beta_5y": "0.71%",
            "beta_3y": "0.62%",
            "beta_1y": "0.38%"
          }
        },
        {
          "symbol": "SPDW",
          "symbolEn": "SPDR Portfolio Developed World ex-US ETF",
          "symbolZh": "SPDR投资组合发达世界(美国除外)ETF",
          "symbolFan": "SPDR投資組合發達世界(美國除外)ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "411.85",
          "returns": {
            "total_return": "57.06%",
            "10y": "108.20%",
            "5y": "37.96%",
            "3y": "53.82%",
            "1y": "27.18%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.70%",
            "beta_1y": "0.98%"
          }
        },
        {
          "symbol": "SPY",
          "symbolEn": "SPDR S&P 500 ETF Trust",
          "symbolZh": "标普500ETF-SPDR",
          "symbolFan": "標普500ETF-SPDR",
          "tick": [],
          "focus": "大盘",
          "fundSize": "7915.63",
          "returns": {
            "total_return": "1585.19%",
            "10y": "257.66%",
            "5y": "77.65%",
            "3y": "70.76%",
            "1y": "23.45%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.01%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "SPYG",
          "symbolEn": "SPDR Portfolio S&P 500 Growth ETF",
          "symbolZh": "SPDR Portfolio S&P 500 Growth ETF",
          "symbolFan": "SPDR Portfolio S&P 500 Growth ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "532.55",
          "returns": {
            "total_return": "383.35%",
            "10y": "369.14%",
            "5y": "92.36%",
            "3y": "96.46%",
            "1y": "28.28%"
          },
          "betas": {
            "beta_5y": "1.18%",
            "beta_3y": "1.18%",
            "beta_1y": "1.28%"
          }
        },
        {
          "symbol": "SPYV",
          "symbolEn": "SPDR Portfolio S&P 500 Value ETF",
          "symbolZh": "SPDR Portfolio S&P 500 Value ETF",
          "symbolFan": "SPDR Portfolio S&P 500 Value ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "355.05",
          "returns": {
            "total_return": "268.64%",
            "10y": "145.30%",
            "5y": "55.62%",
            "3y": "42.80%",
            "1y": "18.19%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.81%",
            "beta_1y": "0.67%"
          }
        },
        {
          "symbol": "TIP",
          "symbolEn": "iShares TIPS Bond ETF",
          "symbolZh": "通胀债券指数ETF-iShares",
          "symbolFan": "通脹債券指數ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "149.35",
          "returns": {
            "total_return": "7.42%",
            "10y": "-5.78%",
            "5y": "-14.14%",
            "3y": "1.25%",
            "1y": "0.32%"
          },
          "betas": {
            "beta_5y": "0.28%",
            "beta_3y": "0.14%",
            "beta_1y": "0.11%"
          }
        },
        {
          "symbol": "UNG",
          "symbolEn": "United States Natural Gas Fund ETF",
          "symbolZh": "美国天然气ETF",
          "symbolFan": "美國天然氣ETF",
          "tick": [],
          "focus": "天然气",
          "fundSize": "4.44",
          "returns": {
            "total_return": "-99.82%",
            "10y": "-90.75%",
            "5y": "-74.40%",
            "3y": "-60.53%",
            "1y": "-33.39%"
          },
          "betas": {
            "beta_5y": "0.08%",
            "beta_3y": "-0.31%",
            "beta_1y": "-0.44%"
          }
        },
        {
          "symbol": "URA",
          "symbolEn": "Global X Uranium ETF",
          "symbolZh": "铀价ETF-Global X",
          "symbolFan": "鈾價ETF-Global X",
          "tick": [],
          "focus": "主题",
          "fundSize": "66.52",
          "returns": {
            "total_return": "-54.47%",
            "10y": "225.50%",
            "5y": "122.80%",
            "3y": "112.62%",
            "1y": "23.56%"
          },
          "betas": {
            "beta_5y": "1.09%",
            "beta_3y": "1.15%",
            "beta_1y": "1.91%"
          }
        },
        {
          "symbol": "USO",
          "symbolEn": "United States Oil Fund LP ETF",
          "symbolZh": "美国原油ETF",
          "symbolFan": "美國原油ETF",
          "tick": [],
          "focus": "原油",
          "fundSize": "18.29",
          "returns": {
            "total_return": "-79.08%",
            "10y": "24.71%",
            "5y": "138.73%",
            "3y": "78.92%",
            "1y": "42.01%"
          },
          "betas": {
            "beta_5y": "-0.03%",
            "beta_3y": "-0.53%",
            "beta_1y": "-1.30%"
          }
        },
        {
          "symbol": "VB",
          "symbolEn": "Vanguard Small-Cap ETF",
          "symbolZh": "小盘股ETF-Vanguard",
          "symbolFan": "小盤股ETF-Vanguard",
          "tick": [],
          "focus": "小盘",
          "fundSize": "841.57",
          "returns": {
            "total_return": "499.69%",
            "10y": "155.80%",
            "5y": "32.97%",
            "3y": "50.37%",
            "1y": "26.89%"
          },
          "betas": {
            "beta_5y": "1.06%",
            "beta_3y": "1.15%",
            "beta_1y": "0.93%"
          }
        },
        {
          "symbol": "VDE",
          "symbolEn": "Vanguard Energy ETF",
          "symbolZh": "能源指数ETF-Vanguard",
          "symbolFan": "能源指數ETF-Vanguard",
          "tick": [],
          "focus": "能源",
          "fundSize": "94.92",
          "returns": {
            "total_return": "206.29%",
            "10y": "64.79%",
            "5y": "108.23%",
            "3y": "38.99%",
            "1y": "23.89%"
          },
          "betas": {
            "beta_5y": "0.44%",
            "beta_3y": "0.05%",
            "beta_1y": "-0.62%"
          }
        },
        {
          "symbol": "VEA",
          "symbolEn": "Vanguard FTSE Developed Markets ETF",
          "symbolZh": "富时成熟市场ETF-Vanguard",
          "symbolFan": "富時成熟市場ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "2330.62",
          "returns": {
            "total_return": "48.51%",
            "10y": "106.01%",
            "5y": "39.29%",
            "3y": "52.99%",
            "1y": "28.09%"
          },
          "betas": {
            "beta_5y": "0.84%",
            "beta_3y": "0.73%",
            "beta_1y": "1.05%"
          }
        },
        {
          "symbol": "VEU",
          "symbolEn": "Vanguard FTSE All World ex US Index Fund Investor Shares",
          "symbolZh": "富时全球(除美国)ETF-Vanguard",
          "symbolFan": "富時全球(除美國)ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "674.43",
          "returns": {
            "total_return": "66.26%",
            "10y": "100.55%",
            "5y": "32.71%",
            "3y": "51.24%",
            "1y": "27.20%"
          },
          "betas": {
            "beta_5y": "0.77%",
            "beta_3y": "0.70%",
            "beta_1y": "1.04%"
          }
        },
        {
          "symbol": "VGT",
          "symbolEn": "Vanguard Information Technology ETF",
          "symbolZh": "资讯科技ETF-Vanguard",
          "symbolFan": "資訊科技ETF-Vanguard",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "1475.53",
          "returns": {
            "total_return": "1819.24%",
            "10y": "764.15%",
            "5y": "142.78%",
            "3y": "114.24%",
            "1y": "48.32%"
          },
          "betas": {
            "beta_5y": "1.35%",
            "beta_3y": "1.47%",
            "beta_1y": "1.47%"
          }
        },
        {
          "symbol": "VHT",
          "symbolEn": "Vanguard Health Care ETF",
          "symbolZh": "健康护理股ETF-Vanguard",
          "symbolFan": "健康護理股ETF-Vanguard",
          "tick": [],
          "focus": "卫生保健",
          "fundSize": "169.47",
          "returns": {
            "total_return": "465.45%",
            "10y": "117.82%",
            "5y": "15.97%",
            "3y": "16.59%",
            "1y": "13.61%"
          },
          "betas": {
            "beta_5y": "0.62%",
            "beta_3y": "0.56%",
            "beta_1y": "0.51%"
          }
        },
        {
          "symbol": "VIG",
          "symbolEn": "Vanguard Dividend Appreciation Index Fund",
          "symbolZh": "递增股利ETF-Vanguard",
          "symbolFan": "遞增股利ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1096.07",
          "returns": {
            "total_return": "371.77%",
            "10y": "185.17%",
            "5y": "54.41%",
            "3y": "46.93%",
            "1y": "17.07%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.78%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "VNQ",
          "symbolEn": "Vanguard Real Estate Index Fund",
          "symbolZh": "不动产信托指数ETF-Vanguard",
          "symbolFan": "不動產信託指數ETF-Vanguard",
          "tick": [],
          "focus": "房地产",
          "fundSize": "383.25",
          "returns": {
            "total_return": "91.80%",
            "10y": "11.39%",
            "5y": "-7.19%",
            "3y": "16.77%",
            "1y": "6.36%"
          },
          "betas": {
            "beta_5y": "1.00%",
            "beta_3y": "0.94%",
            "beta_1y": "0.58%"
          }
        },
        {
          "symbol": "VO",
          "symbolEn": "Vanguard Mid-Cap ETF",
          "symbolZh": "中盘股ETF-Vanguard",
          "symbolFan": "中盤股ETF-Vanguard",
          "tick": [],
          "focus": "中盘",
          "fundSize": "1125.58",
          "returns": {
            "total_return": "547.98%",
            "10y": "159.89%",
            "5y": "36.91%",
            "3y": "48.14%",
            "1y": "16.75%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.00%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "VOE",
          "symbolEn": "Vanguard Mid-Cap Value Index Fund",
          "symbolZh": "中盘价值股ETF-Vanguard",
          "symbolFan": "中盤價值股ETF-Vanguard",
          "tick": [],
          "focus": "中盘",
          "fundSize": "238.06",
          "returns": {
            "total_return": "286.56%",
            "10y": "121.88%",
            "5y": "40.74%",
            "3y": "44.88%",
            "1y": "20.61%"
          },
          "betas": {
            "beta_5y": "0.86%",
            "beta_3y": "0.82%",
            "beta_1y": "0.52%"
          }
        },
        {
          "symbol": "VOO",
          "symbolEn": "Vanguard S&P 500 ETF",
          "symbolZh": "标普500ETF-Vanguard",
          "symbolFan": "標普500ETF-Vanguard",
          "tick": [],
          "focus": "大盘",
          "fundSize": "10471.58",
          "returns": {
            "total_return": "564.79%",
            "10y": "256.57%",
            "5y": "77.09%",
            "3y": "70.22%",
            "1y": "23.49%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.01%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "VT",
          "symbolEn": "Vanguard Total World Stock Index Fund",
          "symbolZh": "全球股市指数ETF-Vanguard",
          "symbolFan": "全球股市指數ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "780.02",
          "returns": {
            "total_return": "213.32%",
            "10y": "172.54%",
            "5y": "52.98%",
            "3y": "61.51%",
            "1y": "24.56%"
          },
          "betas": {
            "beta_5y": "0.93%",
            "beta_3y": "0.91%",
            "beta_1y": "1.02%"
          }
        },
        {
          "symbol": "VTI",
          "symbolEn": "Vanguard Total Stock Market ETF",
          "symbolZh": "整体股市指数ETF-Vanguard",
          "symbolFan": "整體股市指數ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "6673.17",
          "returns": {
            "total_return": "538.88%",
            "10y": "244.67%",
            "5y": "67.79%",
            "3y": "68.88%",
            "1y": "23.94%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.04%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "VTV",
          "symbolEn": "Vanguard Value Index Fund",
          "symbolZh": "价值股ETF-Vanguard",
          "symbolFan": "價值股ETF-Vanguard",
          "tick": [],
          "focus": "价值股",
          "fundSize": "1891.92",
          "returns": {
            "total_return": "336.99%",
            "10y": "158.17%",
            "5y": "59.25%",
            "3y": "53.16%",
            "1y": "24.50%"
          },
          "betas": {
            "beta_5y": "0.76%",
            "beta_3y": "0.73%",
            "beta_1y": "0.57%"
          }
        },
        {
          "symbol": "VUG",
          "symbolEn": "Vanguard Growth Index Fund",
          "symbolZh": "成长股ETF-Vanguard",
          "symbolFan": "成長股ETF-Vanguard",
          "tick": [],
          "focus": "大盘",
          "fundSize": "2279.34",
          "returns": {
            "total_return": "937.49%",
            "10y": "380.46%",
            "5y": "84.91%",
            "3y": "86.09%",
            "1y": "21.85%"
          },
          "betas": {
            "beta_5y": "1.23%",
            "beta_3y": "1.24%",
            "beta_1y": "1.30%"
          }
        },
        {
          "symbol": "VWO",
          "symbolEn": "Vanguard Emerging Markets Stock Index Fund",
          "symbolZh": "富时新兴市场ETF-Vanguard",
          "symbolFan": "富時新興市場ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1235.73",
          "returns": {
            "total_return": "137.81%",
            "10y": "77.37%",
            "5y": "11.07%",
            "3y": "43.02%",
            "1y": "23.22%"
          },
          "betas": {
            "beta_5y": "0.62%",
            "beta_3y": "0.65%",
            "beta_1y": "1.05%"
          }
        },
        {
          "symbol": "VXF",
          "symbolEn": "Vanguard Extended Markets Index Fund",
          "symbolZh": "扩展市场ETF-Vanguard",
          "symbolFan": "擴展市場ETF-Vanguard",
          "tick": [],
          "focus": "拓展市场",
          "fundSize": "310.32",
          "returns": {
            "total_return": "669.43%",
            "10y": "179.00%",
            "5y": "29.14%",
            "3y": "61.57%",
            "1y": "27.24%"
          },
          "betas": {
            "beta_5y": "1.14%",
            "beta_3y": "1.27%",
            "beta_1y": "1.04%"
          }
        },
        {
          "symbol": "VYM",
          "symbolEn": "Vanguard High Dividend Yield Index Fund",
          "symbolZh": "高股利收益ETF-Vanguard",
          "symbolFan": "高股利收益ETF-Vanguard",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "795.98",
          "returns": {
            "total_return": "214.95%",
            "10y": "125.04%",
            "5y": "53.23%",
            "3y": "49.78%",
            "1y": "21.55%"
          },
          "betas": {
            "beta_5y": "0.74%",
            "beta_3y": "0.71%",
            "beta_1y": "0.63%"
          }
        },
        {
          "symbol": "XLB",
          "symbolEn": "Materials Select Sector SPDR",
          "symbolZh": "SPDR原物料类ETF",
          "symbolFan": "SPDR原物料類ETF",
          "tick": [],
          "focus": "材料",
          "fundSize": "83.79",
          "returns": {
            "total_return": "400.64%",
            "10y": "121.83%",
            "5y": "28.10%",
            "3y": "29.14%",
            "1y": "18.39%"
          },
          "betas": {
            "beta_5y": "0.93%",
            "beta_3y": "0.76%",
            "beta_1y": "0.66%"
          }
        },
        {
          "symbol": "XLE",
          "symbolEn": "Energy Select Sector SPDR Fund",
          "symbolZh": "能源指数ETF-SPDR",
          "symbolFan": "能源指數ETF-SPDR",
          "tick": [],
          "focus": "能源",
          "fundSize": "375.95",
          "returns": {
            "total_return": "369.02%",
            "10y": "63.44%",
            "5y": "106.85%",
            "3y": "36.91%",
            "1y": "23.45%"
          },
          "betas": {
            "beta_5y": "0.43%",
            "beta_3y": "0.03%",
            "beta_1y": "-0.65%"
          }
        },
        {
          "symbol": "XLF",
          "symbolEn": "Financial Select Sector SPDR Fund",
          "symbolZh": "金融行业ETF-SPDR",
          "symbolFan": "金融行業ETF-SPDR",
          "tick": [],
          "focus": "财务指标",
          "fundSize": "511.79",
          "returns": {
            "total_return": "183.67%",
            "10y": "193.80%",
            "5y": "51.74%",
            "3y": "61.89%",
            "1y": "7.52%"
          },
          "betas": {
            "beta_5y": "0.87%",
            "beta_3y": "0.83%",
            "beta_1y": "0.78%"
          }
        },
        {
          "symbol": "XLI",
          "symbolEn": "Industrial Select Sector SPDR Fund",
          "symbolZh": "工业指数ETF-SPDR",
          "symbolFan": "工業指數ETF-SPDR",
          "tick": [],
          "focus": "工业",
          "fundSize": "320.23",
          "returns": {
            "total_return": "673.50%",
            "10y": "223.20%",
            "5y": "80.09%",
            "3y": "70.57%",
            "1y": "25.51%"
          },
          "betas": {
            "beta_5y": "1.00%",
            "beta_3y": "1.01%",
            "beta_1y": "0.73%"
          }
        },
        {
          "symbol": "XLK",
          "symbolEn": "Technology Select Sector SPDR Fund",
          "symbolZh": "科技行业精选指数ETF-SPDR",
          "symbolFan": "科技行業精選指數ETF-SPDR",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "1253.41",
          "returns": {
            "total_return": "1046.69%",
            "10y": "759.19%",
            "5y": "160.39%",
            "3y": "115.38%",
            "1y": "53.54%"
          },
          "betas": {
            "beta_5y": "1.34%",
            "beta_3y": "1.46%",
            "beta_1y": "1.52%"
          }
        },
        {
          "symbol": "XLP",
          "symbolEn": "Consumer Staples Select Sector SPDR",
          "symbolZh": "日常消费品精选行业指数ETF-SPDR",
          "symbolFan": "日常消費品精選行業指數ETF-SPDR",
          "tick": [],
          "focus": "必需消费品",
          "fundSize": "143.78",
          "returns": {
            "total_return": "223.40%",
            "10y": "56.09%",
            "5y": "20.30%",
            "3y": "14.64%",
            "1y": "3.32%"
          },
          "betas": {
            "beta_5y": "0.49%",
            "beta_3y": "0.43%",
            "beta_1y": "0.19%"
          }
        },
        {
          "symbol": "XLU",
          "symbolEn": "Utilities Select Sector SPDR Fund",
          "symbolZh": "公用事业精选行业指数ETF-SPDR",
          "symbolFan": "公用事業精選行業指數ETF-SPDR",
          "tick": [],
          "focus": "公用事业",
          "fundSize": "227.74",
          "returns": {
            "total_return": "193.95%",
            "10y": "76.71%",
            "5y": "35.90%",
            "3y": "33.94%",
            "1y": "9.91%"
          },
          "betas": {
            "beta_5y": "0.59%",
            "beta_3y": "0.41%",
            "beta_1y": "-0.01%"
          }
        },
        {
          "symbol": "XLV",
          "symbolEn": "Health Care Select Sector SPDR",
          "symbolZh": "医疗保健精选行业指数ETF-SPDR",
          "symbolFan": "醫療保健精選行業指數ETF-SPDR",
          "tick": [],
          "focus": "卫生保健",
          "fundSize": "390.90",
          "returns": {
            "total_return": "507.38%",
            "10y": "112.57%",
            "5y": "21.31%",
            "3y": "15.63%",
            "1y": "11.55%"
          },
          "betas": {
            "beta_5y": "0.58%",
            "beta_3y": "0.50%",
            "beta_1y": "0.43%"
          }
        },
        {
          "symbol": "XLY",
          "symbolEn": "Consumer Discretionary Select Sector SPDR Fund",
          "symbolZh": "非必需消费类ETF-SPDR",
          "symbolFan": "非必需消費類ETF-SPDR",
          "tick": [],
          "focus": "非必需消费品",
          "fundSize": "228.19",
          "returns": {
            "total_return": "812.50%",
            "10y": "195.56%",
            "5y": "34.45%",
            "3y": "42.39%",
            "1y": "8.53%"
          },
          "betas": {
            "beta_5y": "1.21%",
            "beta_3y": "1.20%",
            "beta_1y": "1.29%"
          }
        },
        {
          "symbol": "AAXJ",
          "symbolEn": "iShares MSCI All Country Asia",
          "symbolZh": "亚洲(除日本)ETF-iShares",
          "symbolFan": "亞洲(除日本)ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "40.27",
          "returns": {
            "total_return": "137.46%",
            "10y": "124.10%",
            "5y": "27.73%",
            "3y": "72.56%",
            "1y": "47.56%"
          },
          "betas": {
            "beta_5y": "0.72%",
            "beta_3y": "0.83%",
            "beta_1y": "1.33%"
          }
        },
        {
          "symbol": "ACWI",
          "symbolEn": "iShares MSCI ACWI ETF",
          "symbolZh": "iShares MSCI ACWI ETF",
          "symbolFan": "iShares MSCI ACWI ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "330.30",
          "returns": {
            "total_return": "211.00%",
            "10y": "177.84%",
            "5y": "56.70%",
            "3y": "62.24%",
            "1y": "24.76%"
          },
          "betas": {
            "beta_5y": "0.92%",
            "beta_3y": "0.89%",
            "beta_1y": "1.02%"
          }
        },
        {
          "symbol": "BND",
          "symbolEn": "Vanguard Total Bond Market Index Fund",
          "symbolZh": "总债券市场ETF-Vanguard",
          "symbolFan": "總債券市場ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "1582.72",
          "returns": {
            "total_return": "-2.57%",
            "10y": "-12.63%",
            "5y": "-14.68%",
            "3y": "1.06%",
            "1y": "0.62%"
          },
          "betas": {
            "beta_5y": "0.25%",
            "beta_3y": "0.21%",
            "beta_1y": "0.10%"
          }
        },
        {
          "symbol": "BNDX",
          "symbolEn": "Vanguard Total International Bond ETF",
          "symbolZh": "总体国际债券ETF-Vanguard",
          "symbolFan": "總體國際債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "823.36",
          "returns": {
            "total_return": "-4.53%",
            "10y": "-12.64%",
            "5y": "-15.39%",
            "3y": "-0.54%",
            "1y": "-2.03%"
          },
          "betas": {
            "beta_5y": "0.22%",
            "beta_3y": "0.18%",
            "beta_1y": "0.12%"
          }
        },
        {
          "symbol": "DVY",
          "symbolEn": "iShares Select Dividend ETF",
          "symbolZh": "股息指数ETF-iShares Dow Jones",
          "symbolFan": "股息指數ETF-iShares Dow Jones",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "226.62",
          "returns": {
            "total_return": "202.86%",
            "10y": "83.61%",
            "5y": "32.77%",
            "3y": "34.55%",
            "1y": "17.85%"
          },
          "betas": {
            "beta_5y": "0.68%",
            "beta_3y": "0.62%",
            "beta_1y": "0.39%"
          }
        },
        {
          "symbol": "EMB",
          "symbolEn": "iShares JP Morgan USD Emerging Markets Bond ETF",
          "symbolZh": "新兴市场美元债ETF-iShares",
          "symbolFan": "新興市場美元債ETF-iShares",
          "tick": [],
          "focus": "广泛信用",
          "fundSize": "140.99",
          "returns": {
            "total_return": "-4.71%",
            "10y": "-14.14%",
            "5y": "-14.14%",
            "3y": "13.19%",
            "1y": "5.59%"
          },
          "betas": {
            "beta_5y": "0.51%",
            "beta_3y": "0.43%",
            "beta_1y": "0.31%"
          }
        },
        {
          "symbol": "IBB",
          "symbolEn": "iShares BIOTECHNOLOGY ETF",
          "symbolZh": "生物科技指数ETF-iShares",
          "symbolFan": "生物科技指數ETF-iShares",
          "tick": [],
          "focus": "卫生保健",
          "fundSize": "81.75",
          "returns": {
            "total_return": "418.25%",
            "10y": "98.60%",
            "5y": "9.92%",
            "3y": "32.13%",
            "1y": "36.50%"
          },
          "betas": {
            "beta_5y": "0.73%",
            "beta_3y": "0.68%",
            "beta_1y": "0.77%"
          }
        },
        {
          "symbol": "ICLN",
          "symbolEn": "iShares Global Clean Energy ETF",
          "symbolZh": "环球清洁能源ETF-iShares",
          "symbolFan": "環球清潔能源ETF-iShares",
          "tick": [],
          "focus": "主题",
          "fundSize": "30.56",
          "returns": {
            "total_return": "-60.80%",
            "10y": "141.22%",
            "5y": "-9.10%",
            "3y": "9.12%",
            "1y": "60.63%"
          },
          "betas": {
            "beta_5y": "1.07%",
            "beta_3y": "1.07%",
            "beta_1y": "1.12%"
          }
        },
        {
          "symbol": "IEI",
          "symbolEn": "iShares 3-7 Year Treasury Bond ETF",
          "symbolZh": "美国国债3-7年ETF-iShares",
          "symbolFan": "美國國債3-7年ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "183.72",
          "returns": {
            "total_return": "16.90%",
            "10y": "-7.78%",
            "5y": "-10.26%",
            "3y": "1.05%",
            "1y": "-0.75%"
          },
          "betas": {
            "beta_5y": "0.14%",
            "beta_3y": "0.09%",
            "beta_1y": "0.06%"
          }
        },
        {
          "symbol": "INDY",
          "symbolEn": "iShares India 50 ETF",
          "symbolZh": "iShares安硕印度50 ETF",
          "symbolFan": "iShares安碩印度50 ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "5.56",
          "returns": {
            "total_return": "72.67%",
            "10y": "53.83%",
            "5y": "-7.14%",
            "3y": "-1.38%",
            "1y": "-18.60%"
          },
          "betas": {
            "beta_5y": "0.45%",
            "beta_3y": "0.41%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "IUSG",
          "symbolEn": "iShares Core S&P US Growth ETF",
          "symbolZh": "核心标普美国增长ETF-iShares",
          "symbolFan": "核心標普美國增長ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "322.61",
          "returns": {
            "total_return": "476.62%",
            "10y": "355.80%",
            "5y": "89.62%",
            "3y": "92.22%",
            "1y": "28.39%"
          },
          "betas": {
            "beta_5y": "1.17%",
            "beta_3y": "1.18%",
            "beta_1y": "1.26%"
          }
        },
        {
          "symbol": "IUSV",
          "symbolEn": "iShares Core S&P US Value ETF",
          "symbolZh": "核心美国价值ETF-iShares",
          "symbolFan": "核心美國價值ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "264.08",
          "returns": {
            "total_return": "357.75%",
            "10y": "147.37%",
            "5y": "55.08%",
            "3y": "40.74%",
            "1y": "18.35%"
          },
          "betas": {
            "beta_5y": "0.84%",
            "beta_3y": "0.83%",
            "beta_1y": "0.69%"
          }
        },
        {
          "symbol": "MCHI",
          "symbolEn": "iShares MSCI China ETF",
          "symbolZh": "MSCI中国ETF-iShares",
          "symbolFan": "MSCI中國ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "63.35",
          "returns": {
            "total_return": "2.53%",
            "10y": "29.62%",
            "5y": "-34.06%",
            "3y": "11.86%",
            "1y": "-3.25%"
          },
          "betas": {
            "beta_5y": "0.33%",
            "beta_3y": "0.36%",
            "beta_1y": "0.99%"
          }
        },
        {
          "symbol": "PFF",
          "symbolEn": "iShares Preferred and Income Securities ETF",
          "symbolZh": "iShares优先股和收益证券ETF",
          "symbolFan": "iShares優先股和收益證券ETF",
          "tick": [],
          "focus": "广泛信用",
          "fundSize": "135.55",
          "returns": {
            "total_return": "-38.01%",
            "10y": "-20.99%",
            "5y": "-20.24%",
            "3y": "1.77%",
            "1y": "2.81%"
          },
          "betas": {
            "beta_5y": "0.53%",
            "beta_3y": "0.51%",
            "beta_1y": "0.40%"
          }
        },
        {
          "symbol": "QQQ",
          "symbolEn": "Invesco QQQ Trust Series 1",
          "symbolZh": "纳指100ETF-Invesco QQQ Trust",
          "symbolFan": "納指100ETF-Invesco QQQ Trust",
          "tick": [],
          "focus": "大盘",
          "fundSize": "4953.26",
          "returns": {
            "total_return": "1313.22%",
            "10y": "571.91%",
            "5y": "110.26%",
            "3y": "98.43%",
            "1y": "35.88%"
          },
          "betas": {
            "beta_5y": "1.23%",
            "beta_3y": "1.23%",
            "beta_1y": "1.31%"
          }
        },
        {
          "symbol": "SHV",
          "symbolEn": "iShares Barclays Short Treasury Bond Fund",
          "symbolZh": "美国短期国债ETF-iShares",
          "symbolFan": "美國短期國債ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "207.48",
          "returns": {
            "total_return": "1.38%",
            "10y": "-0.20%",
            "5y": "-0.27%",
            "3y": "-0.03%",
            "1y": "-0.04%"
          },
          "betas": {
            "beta_5y": "0.01%",
            "beta_3y": "0.00%",
            "beta_1y": "0.01%"
          }
        },
        {
          "symbol": "SHY",
          "symbolEn": "iShares 1-3 Year Treasury Bond ETF",
          "symbolZh": "美国国债1-3年ETF-iShares",
          "symbolFan": "美國國債1-3年ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "254.15",
          "returns": {
            "total_return": "0.74%",
            "10y": "-3.83%",
            "5y": "-4.92%",
            "3y": "0.89%",
            "1y": "-0.67%"
          },
          "betas": {
            "beta_5y": "0.05%",
            "beta_3y": "0.02%",
            "beta_1y": "0.03%"
          }
        },
        {
          "symbol": "SKYY",
          "symbolEn": "First Trust ISE Cloud Computing Index Fund",
          "symbolZh": "First Trust ISE云计算指数基金",
          "symbolFan": "First Trust ISE雲計算指數基金",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "29.39",
          "returns": {
            "total_return": "553.07%",
            "10y": "332.52%",
            "5y": "26.70%",
            "3y": "75.26%",
            "1y": "13.26%"
          },
          "betas": {
            "beta_5y": "1.24%",
            "beta_3y": "1.39%",
            "beta_1y": "1.26%"
          }
        },
        {
          "symbol": "SMH",
          "symbolEn": "VanEck Semiconductor ETF",
          "symbolZh": "半导体指数ETF-VanEck",
          "symbolFan": "半導體指數ETF-VanEck",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "756.77",
          "returns": {
            "total_return": "1256.46%",
            "10y": "2111.88%",
            "5y": "396.77%",
            "3y": "302.14%",
            "1y": "137.76%"
          },
          "betas": {
            "beta_5y": "1.73%",
            "beta_3y": "1.93%",
            "beta_1y": "1.77%"
          }
        },
        {
          "symbol": "SOXX",
          "symbolEn": "iShares Semiconductor ETF",
          "symbolZh": "半导体ETF-iShares",
          "symbolFan": "半導體ETF-iShares",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "456.25",
          "returns": {
            "total_return": "2388.51%",
            "10y": "1808.75%",
            "5y": "312.92%",
            "3y": "254.56%",
            "1y": "164.84%"
          },
          "betas": {
            "beta_5y": "1.80%",
            "beta_3y": "2.14%",
            "beta_1y": "1.91%"
          }
        },
        {
          "symbol": "TLT",
          "symbolEn": "iShares 20+ Year Treasury Bond ETF",
          "symbolZh": "20+年以上美国国债ETF-iShares",
          "symbolFan": "20+年以上美國國債ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "407.14",
          "returns": {
            "total_return": "4.43%",
            "10y": "-36.62%",
            "5y": "-40.16%",
            "3y": "-15.89%",
            "1y": "0.38%"
          },
          "betas": {
            "beta_5y": "0.52%",
            "beta_3y": "0.55%",
            "beta_1y": "0.15%"
          }
        },
        {
          "symbol": "TQQQ",
          "symbolEn": "ProShares UltraPro QQQ ETF",
          "symbolZh": "三倍做多纳指ETF-ProShares",
          "symbolFan": "三倍做多納指ETF-ProShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "404.18",
          "returns": {
            "total_return": "38014.90%",
            "10y": "3719.32%",
            "5y": "178.40%",
            "3y": "292.26%",
            "1y": "107.66%"
          },
          "betas": {
            "beta_5y": "3.71%",
            "beta_3y": "3.93%",
            "beta_1y": "3.99%"
          }
        },
        {
          "symbol": "VCIT",
          "symbolEn": "Vanguard Intermediate-Term Corporate Bond ETF",
          "symbolZh": "中期公司债券ETF-Vanguard",
          "symbolFan": "中期公司債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "668.45",
          "returns": {
            "total_return": "9.57%",
            "10y": "-7.01%",
            "5y": "-13.17%",
            "3y": "4.93%",
            "1y": "0.70%"
          },
          "betas": {
            "beta_5y": "0.33%",
            "beta_3y": "0.27%",
            "beta_1y": "0.17%"
          }
        },
        {
          "symbol": "VCSH",
          "symbolEn": "Vanguard Short-Term Corporate Bond Idx Fd",
          "symbolZh": "短期公司债券ETF-Vanguard",
          "symbolFan": "短期公司債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "447.72",
          "returns": {
            "total_return": "4.71%",
            "10y": "-2.25%",
            "5y": "-4.70%",
            "3y": "4.58%",
            "1y": "-0.18%"
          },
          "betas": {
            "beta_5y": "0.12%",
            "beta_3y": "0.09%",
            "beta_1y": "0.08%"
          }
        },
        {
          "symbol": "VXUS",
          "symbolEn": "Vanguard Total International Stock Index Fund",
          "symbolZh": "全世界股票ETF-Vanguard",
          "symbolFan": "全世界股票ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1556.05",
          "returns": {
            "total_return": "72.06%",
            "10y": "96.78%",
            "5y": "31.23%",
            "3y": "50.15%",
            "1y": "26.51%"
          },
          "betas": {
            "beta_5y": "0.78%",
            "beta_3y": "0.70%",
            "beta_1y": "1.04%"
          }
        }
      ]

      // ==============================
      // ETF "Follow" module (Core Index) data & interaction
      // ==============================
      // 1. 定义多语言年份格式化函数
      function formatYear(yearStr) {
        const href = location.href || "";

        // 后缀型语言
        if (href.includes("zh-cn") || href.includes("/zh/") || href.includes("/jp/")) {
          return yearStr + "年";
        } else if (href.includes("/kr/")) {
          return yearStr + "년";
        } else if (href.includes("/ru/")) {
          return yearStr + " г.";
        } else if (href.includes("/mn/")) {
          return yearStr + " он";
        } else if (href.includes("/ug/")) {
          return yearStr + " يىل";
        }
        // 前置型语言
        else if (href.includes("/vi/")) {
          return "Năm " + yearStr;
        } else if (href.includes("/id/")) {
          return "Tahun " + yearStr;
        } else if (href.includes("/th/")) {
          return "ปี " + yearStr;
        } else if (href.includes("/ar/")) {
          return "عام " + yearStr;
        } else if (href.includes("/hi/")) {
          return "वर्ष " + yearStr;
        }

        // 默认 (英文 /es /pt 等)，直接返回纯数字
        return yearStr;
      }

      // 2. 将配置中的年份替换为函数调用
      const etfFollowConfig = {
        groups: {
          sp500: {
            defaultSymbol: "SPY",
            symbols: ["SPY", "VOO", "IVV"],
          },
          nas100: {
            defaultSymbol: "QQQ",
            symbols: ["QQQ", "TQQQ"],
          },
        },
        symbolMeta: {
          SPY: { issuer: "State Street", year: formatYear("1993") },
          VOO: { issuer: "Vanguard", year: formatYear("2010") },
          IVV: { issuer: "BlackRock", year: formatYear("2000") },
          QQQ: { issuer: "Invesco", year: formatYear("1999") },
          TQQQ: { issuer: "ProShares", year: formatYear("2010") },
        },
        // 全部改为英文 Key
        periods: ["1y", "3y", "5y", "10y"],
      };


      (function () {
        function getLocaleKey() {
          const p = (location && location.pathname) ? location.pathname : "";
          if (p.includes("/zh-cn/")) return "zh";
          if (p.includes("/zh/")) return "fan";
          return "en";
        }

        function getEtfName(item) {
          if (!item) return "--";
          const k = getLocaleKey();
          if (k === "fan") return item.symbolFan || item.symbolEn || item.symbolZh || "--";
          if (k === "zh") return item.symbolZh || item.symbolEn || item.symbolFan || "--";
          return item.symbolEn || item.symbolZh || item.symbolFan || "--";
        }

        function parsePct(v) {
          if (v == null) return null;
          const n = parseFloat(String(v).replace("%", "").replace("+", "").trim());
          return Number.isFinite(n) ? n : null;
        }

        function findEtfBySymbol(symbol) {
          if (!symbol) return null;
          for (let i = 0; i < etfData.length; i++) {
            if (etfData[i].symbol === symbol) return etfData[i];
          }
          return null;
        }

        function renderCard(cardEl, symbol) {
          const item = findEtfBySymbol(symbol);
          const meta = etfFollowConfig.symbolMeta[symbol] || {};

          const issuerEl = cardEl.querySelector('[data-meta="issuer"]');
          const yearEl = cardEl.querySelector('[data-meta="year"]');
          const aumEl = cardEl.querySelector('[data-meta="aum"]');

          if (issuerEl) issuerEl.textContent = meta.issuer || "--";
          if (yearEl) yearEl.textContent = meta.year || "--";
          if (aumEl) aumEl.textContent = (item && item.fundSize) ? String(item.fundSize) : "--";

          etfFollowConfig.periods.forEach((k) => {
            const v = item && item.returns ? item.returns[k] : null;
            const valEl = cardEl.querySelector(`[data-value="${k}"]`);
            if (valEl) valEl.textContent = v || "--";
          });
        }

        function setActiveSymbolTab(cardEl, btn) {
          const tabs = Array.from(cardEl.querySelectorAll(".etf-follow__symbolTab"));
          tabs.forEach((b) => {
            b.classList.remove("is-active");
            b.setAttribute("aria-selected", "false");
          });
          btn.classList.add("is-active");
          btn.setAttribute("aria-selected", "true");

          const symbol = btn.getAttribute("data-symbol");
          if (symbol) renderCard(cardEl, symbol);
        }

        function initCard(cardEl) {
          const tabs = Array.from(cardEl.querySelectorAll(".etf-follow__symbolTab"));
          if (tabs.length) {
            const active = tabs.find((t) => t.classList.contains("is-active")) || tabs[0];
            setActiveSymbolTab(cardEl, active);

            tabs.forEach((btn) => {
              btn.addEventListener("click", function () {
                setActiveSymbolTab(cardEl, btn);
              });
            });
          }

          const perfItems = Array.from(cardEl.querySelectorAll(".etf-follow__perfItem"));
          perfItems.forEach((it) => {
            it.addEventListener("mouseenter", function () {
              perfItems.forEach((x) => x.classList.remove("is-active"));
              it.classList.add("is-active");
            });
          });
        }

        // ------------------------------
        // History performance panel (Top 10)
        // ------------------------------
        function getHistoryTop10(metric) {
          const list = [];
          for (let i = 0; i < etfData.length; i++) {
            const it = etfData[i];
            const raw = it && it.returns ? it.returns[metric] : null;
            const num = parsePct(raw);
            if (num == null) continue;
            list.push({ item: it, raw: raw, num: num });
          }
          list.sort((a, b) => b.num - a.num);
          return list.slice(0, 10);
        }

        function renderHistory(root, metric) {
          const box = root.querySelector('.etf-follow__historyBox');
          if (!box) return;

          const top = getHistoryTop10(metric);
          const top1 = top[0];

          const topSym = box.querySelector('.etf-follow__historyTop1Symbol');
          const topDesc = box.querySelector('.etf-follow__historyTop1Desc');
          const topVal = box.querySelector('.etf-follow__historyTop1Value');

          if (topSym) topSym.textContent = top1 ? top1.item.symbol : "--";
          if (topDesc) topDesc.textContent = top1 ? getEtfName(top1.item) : "--";
          if (topVal) topVal.textContent = top1 ? top1.raw : "--";

          const listEl = box.querySelector('.etf-follow__historyList');
          if (!listEl) return;
          // 1. 将 dataset 转为字符串拼接 (例如: 'data-id="1" data-type="stock"')
          const dataAttrs = Object.entries(listEl.dataset)
            .map(([key, value]) => `data-${key.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}="${value}"`)
            .join(' ');
          const sourceDataset = Object.assign({}, listEl.dataset);
          listEl.innerHTML = "";

          for (let i = 1; i < top.length; i++) {
            const row = top[i];
            const rank = i + 1;
            const div = document.createElement("div");
            div.className = "etf-follow__historyRow";
            Object.assign(div.dataset, sourceDataset);
            // 2. 将数据属性嵌入 HTML 字符串
            div.innerHTML = `
    <div ${dataAttrs} class="etf-follow__historyCell etf-follow__historyCell--rank">${rank}</div>
    <div ${dataAttrs} class="etf-follow__historyCell etf-follow__historyCell--symbol">${row.item.symbol}</div>
    <div ${dataAttrs} class="etf-follow__historyCell etf-follow__historyCell--desc">${getEtfName(row.item)}</div>
    <div ${dataAttrs} class="etf-follow__historyCell etf-follow__historyCell--ret">${row.raw}</div>
  `;
            listEl.appendChild(div);
          }
        }

        function initHistory(root) {
          const box = root.querySelector('.etf-follow__historyBox');

          if (!box) return;

          // 默认选用英文 Key
          let metric = "total_return";

          const btn = box.querySelector('.etf-follow__historySelect');
          const menu = box.querySelector('.etf-follow__historyMenu');
          const options = Array.from(box.querySelectorAll('.etf-follow__historyOption'));
          const selectText = box.querySelector('.etf-follow__historySelectText');

          // 初始化时从 HTML 节点里读取要显示的文字（解决多语言问题）
          const initialOpt = box.querySelector(`.etf-follow__historyOption[data-metric="${metric}"]`);
          if (initialOpt && selectText) {
            selectText.textContent = initialOpt.textContent;
          }

          function closeMenu() {
            if (!menu) return;
            menu.hidden = true;
            if (btn) btn.setAttribute("aria-expanded", "false");
          }

          function openMenu() {
            if (!menu) return;
            menu.hidden = false;
            if (btn) btn.setAttribute("aria-expanded", "true");
          }

          if (btn && menu) {

            btn.addEventListener("click", function (e) {
              e.preventDefault();
              if (menu.hidden) openMenu();
              else closeMenu();
            });

            document.addEventListener("click", function (e) {
              if (!box.contains(e.target)) closeMenu();
            });
          }

          options.forEach((opt) => {
            opt.addEventListener("click", function () {
              const m = opt.getAttribute("data-metric");
              if (m) {
                metric = m;
                // 点击时，直接把按钮内的中文/繁体字赋予给显示框
                if (selectText) selectText.textContent = opt.textContent;
              }
              closeMenu();
              renderHistory(root, metric);
            });
          });

          renderHistory(root, metric);
        }

        // ------------------------------
        // Volatility style panel (beta 1y)
        // ------------------------------
        const etfVolatilityConfig = {
          styles: {
            sync: {
              title: "β ≈ 1",
              symbols: ["SPY", "VOO", "VTI"],
            },
            trend: {
              title: "β > 1",
              symbols: ["TQQQ", "SOXX", "SMH"],
            },
            low: {
              title: "0 < β < 1",
              symbols: ["TLT", "BND", "IEI"],
            },
            inverse: {
              title: "β < 0",
              symbols: ["USO", "UNG", "XLE"],
            },
          },
          // 改为英文 Key
          betaKey: "beta_1y",
        };

        function formatBeta(item) {
          const raw = item && item.betas ? item.betas[etfVolatilityConfig.betaKey] : null;
          const n = raw == null ? null : parseFloat(String(raw));
          if (!Number.isFinite(n)) return "--";
          return n.toFixed(2);
        }

        function renderVolatility(root, styleKey) {
          const box = root.querySelector(".etf-follow__volBox");
          if (!box) return;
          const cfg = etfVolatilityConfig.styles[styleKey] || etfVolatilityConfig.styles.sync;
          const activeTab = box.querySelector(`.etf-follow__volTab[data-style="${styleKey}"]`);

          const titleEl = box.querySelector(".etf-follow__volTitle");
          const descEl = box.querySelector(".etf-follow__volDesc");
          if (titleEl) titleEl.textContent = cfg.title;
          if (descEl) descEl.textContent = activeTab ? activeTab.getAttribute("data-desc") || "" : "";

          const listEl = box.querySelector(".etf-follow__volList");
          if (!listEl) return;
          const sourceDataset = Object.assign({}, listEl.dataset);
          const dataAttrs = Object.entries(listEl.dataset)
            .map(([key, value]) => `data-${key.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}="${value}"`)
            .join(' ');
          listEl.innerHTML = "";

          cfg.symbols.forEach((sym) => {
            const item = findEtfBySymbol(sym);
            const row = document.createElement("div");
            row.className = "etf-follow__volRow";
            Object.assign(row.dataset, sourceDataset);
            row.innerHTML = `
        <div ${dataAttrs} class="etf-follow__volLeft">
          <div ${dataAttrs} class="etf-follow__volPill">${sym}</div>
          <div ${dataAttrs} class="etf-follow__volName">${getEtfName(item)}</div>
        </div>
        <div ${dataAttrs} class="etf-follow__volBeta">β ${formatBeta(item)}</div>
      `;
            listEl.appendChild(row);
          });
        }

        function initVolatility(root) {
          const box = root.querySelector(".etf-follow__volBox");
          if (!box) return;

          const tabs = Array.from(box.querySelectorAll(".etf-follow__volTab[data-style]"));
          function setStyle(key) {
            tabs.forEach((t) => {
              const isActive = t.getAttribute("data-style") === key;
              t.classList.toggle("is-active", isActive);
              t.setAttribute("aria-selected", isActive ? "true" : "false");
            });
            renderVolatility(root, key);
          }

          tabs.forEach((btn) => {
            btn.addEventListener("click", function () {
              const key = btn.getAttribute("data-style");
              if (key) setStyle(key);
            });
          });

          const initial = (tabs.find((t) => t.classList.contains("is-active")) || tabs[0])?.getAttribute("data-style") || "sync";
          setStyle(initial);
        }

        function initEtfFollow() {
          const root = document.querySelector(".etf-follow");

          if (!root) return;

          const topTabs = Array.from(root.querySelectorAll(".etf-follow__tab[data-tab]"));
          const panels = Array.from(root.querySelectorAll(".etf-follow__panel[data-panel]"));

          function keepActiveTopTabInView() {
            const active = root.querySelector(".etf-follow__tab.is-active[data-tab]");
            if (!active) return;
            try {
              active.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
            } catch (e) {
              active.scrollIntoView();
            }
          }

          function setTopTab(key) {
            topTabs.forEach((t) => t.classList.toggle("is-active", t.getAttribute("data-tab") === key));
            panels.forEach((p) => p.classList.toggle("is-active", p.getAttribute("data-panel") === key));
          }

          topTabs.forEach((btn) => {
            if (btn.disabled) return;
            btn.addEventListener("click", function () {
              const key = btn.getAttribute("data-tab");
              if (key) setTopTab(key);
              keepActiveTopTabInView();
            });
          });

          const initial = (topTabs.find((t) => t.classList.contains("is-active")) || topTabs[0])?.getAttribute("data-tab") || "core";
          setTopTab(initial);

          const cards = Array.from(root.querySelectorAll(".etf-follow__card"));
          cards.forEach(initCard);

          initHistory(root);
          initVolatility(root);
        }

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", initEtfFollow);
        } else {
          initEtfFollow();
        }
      })();
    },
    initPage() {
      const setTabActIdx = (idx, e) => {
        scrollTabElement.forEach((item, index) => {
          item.classList.remove("active");
        });
        floatTabElement.forEach((item, index) => {
          item.classList.remove("active");
        });
        floatTabElement[idx].classList.add("active");
        scrollTabElement[idx].classList.add("active");
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const leftPad = 32 * rem;
        const wrapper = document.querySelector(".scrollTabWrapper");
        wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
      };
      const scrollTabElement = document.querySelectorAll(
        ".scrollTabWrapper .tabItem"
      );
      const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
      floatTabElement.forEach((item, idx) => {
        item.addEventListener("click", function (e) {
          jumpPage(idx);
        });
      });
      scrollTabElement.forEach((item, idx) => {
        item.addEventListener("click", function (e) {
          jumpPage(idx);
        });
      });
      let tabIndex = 0;

      if (location.href.includes("/commodity/")) {
        tabIndex = 1;
      } else if (location.href.includes("/index-cfds/")) {
        tabIndex = 2;
      } else if (location.href.includes("/share-cfds/")) {
        tabIndex = 3;
      } else if (location.href.includes("/etf/")) {
        tabIndex = 4;
      } else if (location.href.includes("/crypto/")) {
        tabIndex = 5;
      }
      setTabActIdx(tabIndex, { target: floatTabElement[tabIndex] });
      setTabActIdx(tabIndex, { target: scrollTabElement[tabIndex] });
      function jumpPage(idx) {
        const pathArr = location.pathname.split("/");
        const len = pathArr.length;
        const targetArr = ["forex", "commodity", "index-cfds", "share-cfds", "etf", 'crypto'];
        pathArr[len - 2] = targetArr[idx];
        location.href = pathArr.join("/");
      }
      console.log(ProductVM, 1111)
      ProductVM.changeHandle(tabIndex);
      document.addEventListener("mountedSuccess", (e) => {
        ProductVM.changeHandle(tabIndex);
      });

      ; (function initShareHotModule() {
        const root = document.querySelector(".shareHotModule");
        if (!root) return;

        const END_ISO = "2026-09-12T00:00:00+03:00";
        const endMs = new Date(END_ISO).getTime();
        if (!Number.isFinite(endMs)) return;

        const $d = root.querySelector('[data-share-hot="days"]');
        const $h = root.querySelector('[data-share-hot="hours"]');
        const $m = root.querySelector('[data-share-hot="minutes"]');
        const $s = root.querySelector('[data-share-hot="seconds"]');

        const pad2 = (n) => String(n).padStart(2, "0");

        const tick = () => {
          const diffMs = endMs - Date.now();
          if (diffMs <= 0) {
            root.style.display = "none";
            return false;
          }

          const totalSec = Math.floor(diffMs / 1000);
          const days = Math.floor(totalSec / 86400);
          const hours = Math.floor((totalSec % 86400) / 3600);
          const minutes = Math.floor((totalSec % 3600) / 60);
          const seconds = totalSec % 60;

          if ($d) $d.textContent = String(days);
          if ($h) $h.textContent = pad2(hours);
          if ($m) $m.textContent = pad2(minutes);
          if ($s) $s.textContent = pad2(seconds);

          return true;
        };

        if (!tick()) return;
        const timer = setInterval(() => {
          if (!tick()) clearInterval(timer);
        }, 1000);
      })();

      ; (function initShareHotRuleModal() {
        const root = document.querySelector(".shareHotModule");
        if (!root) return;

        const trigger = root.querySelector("[data-share-hot-rule]");
        const modal = document.getElementById("shareHotRuleModal");
        if (!trigger || !modal) return;

        const dialog = modal.querySelector(".shareHotRuleModal-dialog");
        const closeEls = modal.querySelectorAll("[data-share-hot-rule-close]");

        const open = () => {
          modal.classList.add("is-open");
          modal.setAttribute("aria-hidden", "false");
          setTimeout(() => dialog && dialog.focus(), 0);
        };
        const close = () => {
          modal.classList.remove("is-open");
          modal.setAttribute("aria-hidden", "true");
        };

        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          open();
        });

        closeEls.forEach((el) => el.addEventListener("click", close));

        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && modal.classList.contains("is-open")) close();
        });
      })();

    }
  }
}

</script>
<style scoped lang="scss">
@import url("../assets/css/commonQuestion.scss");

* {
  font-family: Inter, Noto Sans Sc, sans-serif;
}

.message-new .gender-btn::before {
  box-sizing: border-box;
}

.message-new {
  max-width: 1200rem;
  padding-inline: calc((100vw - 1200rem) / 2) !important;
  box-sizing: content-box;
}

.message-new .p1 {
  font-size: 48rem !important;
  line-height: 56rem !important;
}

.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}

body.no-scroll {
  overflow: hidden;
}

#pageOverLay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  display: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.pageContainer {
  position: relative;
}

#pageContainer {
  background: var(--ebc-neutral-bg_a)
}

#pageContainer .pageBtn {
  gap: 4rem;
  min-width: 180rem;
  width: fit-content;
  cursor: pointer;
}

#pageContainer a {
  width: fit-content;
  display: block;
  margin-inline: auto;
}

.container1 {
  padding-top: calc(80px + 15rem);
  height: 560rem;
  background: var(--ebc-neutral-bg_c);
}

.container1 .left {
  flex: 0 0 770rem;
}

.container1 .left h2 {
  margin: 24rem 0 64rem;
  color: var(--ebc-text-secondary);
}


.container1 .right {
  height: 412rem;
}

.container1 a {
  margin: 0 !important;
}

@media (max-width: 996px) {
  html {
    overflow-x: hidden;
  }

  body {
    overflow-x: visible !important;
  }

  .message-new .p1 {
    font-size: 48rem !important;
    line-height: 72rem !important;
  }

  .container1 {
    padding: 80rem 32rem;
    height: auto;
    overflow-x: hidden;
  }

  .container1 .right {
    /* width: 586rem; */
    height: 586rem;
    margin: 0 auto 80rem;
  }

  .container1>div {
    flex-direction: column;
  }

  .container1 .left {
    order: 2;
    text-align: center;
    flex: 1;
  }

  .container1 .left h2 {
    margin-top: 16rem;
  }

  #pageContainer .container1 a {
    width: 100%;
  }

  #pageContainer .container1 .left .pageBtn {
    width: 100%;
  }

}


.container2 {
  background: var(--ebc-neutral-bg_a);
  margin-top: -64rem;
}

.pt .floatTab,
.es .floatTab {
  width: 900rem;
}

.floatTab {
  position: sticky;
  transform: translateY(-50%);
  z-index: 98;
  top: 128px;
  margin-inline: auto;
  background: var(--ebc-basecolor-white-85);
  border-radius: var(--ebc-corner-radius-full);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  padding: 4rem;
  gap: 8rem;
  width: 792rem;
  height: 64rem;
}

.floatTab .tabItem {
  flex: 1;
  color: var(--ebc-text-secondary);
}

.floatTab .active {
  border-radius: var(--ebc-corner-radius-full);
  background: var(--ebc-neutral-bg_c);
  color: var(--ebc-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: 500;
}
.shareTradingHours{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16rem;
  box-sizing: border-box;
  width: 100%;
  margin: 50rem 0 20rem;
  padding: 20rem 32rem;
  border-radius: var(--ebc-corner-radius-rc12, 12rem);
  background: #fcf9f5;
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
  line-height: 24rem;
}
.shareTradingHours-label{
  display: inline-flex;
  align-items: center;
  gap: 10rem;
  white-space: nowrap;
}
.shareTradingHours-label img{
  width: 20rem;
  height: 20rem;
}
.shareTradingHours-divider{
  width: 1rem;
  height: 20rem;
  background: rgba(0,0,0,0.12);
}
.shareTradingHours-text{
  display: inline-flex;
  align-items: flex-start;
  white-space: nowrap;
  flex-direction: column;
}
.shareTradingHours-text strong{
  color: var(--ebc-text-primary, #000);
  font-weight: 400;
}
.container2 .container2Content {
  padding: 120rem 0;
}

/* .container2 .container2Content>a:last-of-type{
  display:none!important
} */

.container2 h2 {
  margin-bottom: 16rem;
}

.tradingProductPage .container2 h2 {
  max-width: 850rem;
  margin-inline: auto;
}

.container2 h3 {
  max-width: 850rem;
  margin-inline: auto !important;
}

.container2 h3 {
  margin: 16rem 0;
  color: var(--ebc-text-secondary);
}
.container2{
  margin-top: 0;
}
.container2 h3{
  margin:16rem 0 60rem;
}
.container2 .contentBox {
  padding-top: 120rem;
}
.container2 .pageBtn {
  margin: 60rem auto 0;
}

@media (max-width: 996px) {
  .shareTradingHours{
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24rem;
    margin: 80rem 0;
    padding: 40rem 32rem;
    border-radius: 24rem;
    font-size: 32rem;
    line-height: 48rem;
  }
  .shareTradingHours-label{
    gap: 20rem;
  }
  .shareTradingHours-label img{
    width: 40rem;
    height: 40rem;
  }
  .shareTradingHours-divider{
    display: none;
  }
  .shareTradingHours-text{
    display: flex;
    flex-direction: column;
    gap: 24rem;
    white-space: normal;
  }
  .shareTradingHours-text div{
    line-height: 48rem;
  }
  .shareTradingHours-text strong,
  .shareTradingHours-text span{
    display: block;
  }
  .shareTradingHours-text strong{
    color: var(--ebc-text-primary, #000);
  }
  html {
    height: auto !important;
    min-height: auto !important;
  }

  .container2 {
    padding: 0 32rem;
    margin-top: 0;
  }

  .container2 .container2Content .btnTop {
    height: 64rem;
    font-size: 28rem;
    gap: 8rem;
    line-height: 44rem;
  }

  .container2 .pageBtn {
    height: 80rem;
    font-size: 28rem;
    line-height: 44rem;
    margin-top: 80rem;
  }

  .floatTab {
    display: none !important;
  }

  .container2 .container2Content {
    padding: 64rem 0 160rem;
  }

  .container2 h3 {
    margin: 16rem 0;
  }

  .scrollTab {
    display: inline-flex;
    gap: 16rem;
    min-width: fit-content;
  }

  .scrollTabWrapper {
    overflow-x: auto;
    scroll-behavior: smooth;
    padding: 16rem 32rem;
    margin-top: 64rem;
    background: var(--ebc-neutral-bg_a);
    position: sticky;
    top: 44px;
    z-index: 99
  }

  .scrollTabWrapper::-webkit-scrollbar {
    display: none;
  }

  .scrollTab .tabItem {
    color: var(--ebc-text-secondary);
    padding: 16rem 32rem;
    flex: 1;
    background: var(--ebc-neutral-bg_b);
    border-radius: var(--ebc-corner-radius-full);
    white-space: nowrap;
  }

  .scrollTab .active {
    background: var(--ebc-basecolor-active-500);
    color: var(--ebc-text-primary_white);
    font-weight: 500;
  }
}



.container1 {
  padding-top: 0;
  height: 738rem;
  overflow: hidden;
}

.container1 .left {
  flex: 0 0 585rem;
  padding-top: 160rem;
  position: relative;
  z-index: 2;
}

.container1 .left h2 {
  margin-bottom: 24rem;
}

.container1 .contentBox {
  position: relative;
}

.container1 .iconList {
  gap: 8rem;
  margin-bottom: 64rem;
}

.container1 .iconList>div {
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_a);
  padding: 4rem 8rem;
  display: flex;
  align-items: center;
  gap: 8rem;

}

.container1 .iconList>div svg {
  width: 12rem;
  height: 12rem;
}

.container1 .right {
  position: absolute;
  top: 140rem;
  left: 603rem;
  height: auto;
  width: 624rem;
  pointer-events: none;
}

@media (min-width: 996px) {

  .es .container1 h1,
  .id .container1 h1,
  .mn .container1 h1 {
    font-size: 50rem;
    line-height: 56rem;
  }

  .en .container1 h1,
  .jp .container1 h1,
  .ug .container1 h1,
  .pt .container1 h1,
  .ru .container1 h1,
  .vi .container1 h1 {
    font-size: 55rem;
    line-height: 68rem;
  }

  .ar .container1 .right {
    left: -232rem;
    top: -375rem;
    margin: 0
  }

  .ar .etf-follow__hotArt--em,
  .ar .etf-follow__hotArt--sp {
    right: unset;
    left: 40rem;
  }

  .ar .etf-follow__historyMenu {
    left: unset;
    right: 40rem;
  }
}

@media (max-width: 996px) {
  .container1 {
    padding-top: 0rem;
    height: auto;
  }

  .container1 .left {
    flex: 1;
    padding-top: 650rem;
    z-index: 2;
  }

  .hi .container1 h1 {
    font-size: 62rem
  }

  .container1 .left h2 {
    color: var(--ebc-text-secondary);
    font-size: 28rem;
    font-weight: 400;
    line-height: 44rem;
    /* 157.143% */
    margin-block: 16rem;
  }

  .container1 .iconList {
    justify-content: center;
    gap: 16rem;
  }

  .container1 .right {
    height: auto;
    width: 674rem;
    left: 0rem;
    top: 80rem;
    margin: 0
  }

  .contentBox {
    padding-inline: 32rem;
  }
}

.container2 h3 {
  margin: 16rem 0 60rem;
}

/* .container2 .contentBox {
  padding-top: 88rem;
} */

.container2 .topCardList {
  margin-bottom: 120rem;
  gap: 24rem;
  align-items: stretch;
}

.container2 .topCardList .card {
  flex: 1;
  border-radius: var(--ebc-corner-radius-rc16);
  border: 0;
  background: var(--ebc-neutral-bg_b);
  padding: 32rem 24rem;
}

.container2 .topCardList .card h3 {
  margin: 16rem 0;
  color: var(--ebc-text-primary);
}

.container2 .topCardList .card div {
  color: var(--ebc-text-secondary);
}

.container2 .jyBtn {
  margin-bottom: 60rem;
  min-width: 180rem;
}

@media (max-width: 996px) {
  .container2 .jyBtn {
    height: 80rem;
    margin-bottom: 80rem;
    min-width: unset;
    font-size: 28rem;
    line-height: 44rem;
    font-weight: 500;
  }

  .container2 .topCardList {
    margin-bottom: 160rem;
    gap: 32rem;
    flex-wrap: wrap;
  }

  .container2 .topCardList .card h3 {
    margin: 32rem 0 16rem;
    color: var(--ebc-text-primary);
  }

  .container2 .topCardList .card {
    padding: 32rem;
    flex: 0 0 calc(50% - 16rem);
  }
}

.product-table-tr>div:nth-child(4),
.product-table-th>div:nth-child(4) {
  display: none !important;
}

/* ==============================
   ETF Efficient Section (PC)
   Namespaced to avoid .container* conflicts
   ============================== */
.etf-efficient {
  padding: 60rem 0 120rem;
  background: var(--ebc-neutral-bg_a, #fff);
}

.etf-efficient h3 {
  color: var(--ebc-text-secondary);
}

.etf-efficient__inner {
  display: flex;
  flex-direction: column;
  gap: 60rem;
}

.etf-efficient__header {
  text-align: center;
  max-width: 1200rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16rem;
}

.etf-efficient__grid {
  display: flex;
  flex-direction: column;
  gap: 24rem;
}

.etf-efficient__row {
  display: flex;
  gap: 24rem;
  align-items: stretch;
}

.etf-efficient__row--3 .etf-efficient__card {
  flex: 0 0 calc((100% - 48rem) / 3);
}

.etf-efficient__row--2 .etf-efficient__card {
  flex: 0 0 calc((100% - 24rem) / 2);
}

.etf-efficient__card {
  background: var(--ebc-neutral-bg_b, #f7f7f7);
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  overflow: hidden;
  transition: transform 180ms ease, box-shadow 180ms ease;
  will-change: transform;
}

.etf-efficient__card:hover {
  transform: translateY(-10rem);
  box-shadow: 0 18rem 48rem rgba(0, 0, 0, 0.18);
}

.etf-efficient__card--sm {
  padding: 40rem;
  display: flex;
  flex-direction: column;
  gap: 32rem;
  align-items: flex-start;
}

.etf-efficient__icon {
  width: 40rem;
  height: 40rem;
  display: block;
}

.etf-efficient__card--lg {
  padding: 0 0 40rem;
  display: flex;
  flex-direction: column;
  gap: 40rem;
}

.etf-efficient__media {
  height: 302rem;
  width: 100%;
  overflow: hidden;
  background: var(--ebc-neutral-bg_b, #f7f7f7);
}

.etf-efficient__mediaInner {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Matches the "framed" look in Figma */
  padding: 51rem 84rem 46rem;
  box-sizing: border-box;
}

.etf-efficient__card:first-child .etf-efficient__mediaInner {
  padding-bottom: 26rem;
}

.etf-efficient__mediaInner img {
  display: block;
  width: 420rem;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

.etf-efficient__cardBody {
  padding: 0 40rem;
}

.etf-efficient__cardTitle {
  color: var(--ebc-text-primary, #000);
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
}

.etf-efficient__cardDesc {
  margin-top: 12rem;
  color: var(--ebc-text-secondary, rgba(0, 0, 0, 0.64));
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 400;
}

.etf-efficient__row--3 .etf-efficient__cardDesc {
  margin-top: -20rem;
}

@media (max-width: 996px) {
  .etf-efficient {
    padding: 80rem 0 160rem;
  }

  .etf-efficient__inner {
    gap: 80rem;
  }

  .etf-efficient__header {
    max-width: 686rem;
  }

  .etf-efficient__header h2 {
    font-size: 48rem;
    line-height: 64rem;
  }

  .etf-efficient__header h3 {
    font-size: 24rem;
    line-height: 40rem;
  }

  .etf-efficient__grid {
    gap: 32rem;
  }

  .etf-efficient__row {
    flex-direction: column;
    gap: 32rem;
  }

  .etf-efficient__row--3 .etf-efficient__card,
  .etf-efficient__row--2 .etf-efficient__card {
    flex: 1 1 auto;
  }

  .etf-efficient__card {
    border-radius: var(--ebc-corner-radius-rc16, 16rem);
  }

  .etf-efficient__card--sm {
    padding: 32rem;
    display: grid;
    grid-template-columns: 64rem 1fr;
    column-gap: 32rem;
    row-gap: 8rem;
    align-items: center;
  }

  .etf-efficient__icon {
    width: 64rem;
    height: 64rem;
    grid-column: 1;
    grid-row: 1 / span 2;
  }

  .etf-efficient__cardTitle {
    font-size: 32rem;
    line-height: 48rem;
    grid-column: 2;
  }

  .etf-efficient__cardDesc {
    margin-top: 0;
    font-size: 24rem;
    line-height: 40rem;
    grid-column: 2;
  }

  .etf-efficient__row--3 .etf-efficient__cardDesc {
    margin-top: 0;
  }

  .etf-efficient__card--lg {
    padding: 32rem;
    gap: 32rem;
  }

  .etf-efficient__media {
    height: 302rem;
  }

  .etf-efficient__mediaInner {
    padding: 0;
    width: 588rem;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
  }

  .etf-efficient__mediaInner img {
    width: 469rem;
  }

  .etf-efficient__cardBody {
    padding: 0;
  }
}

/* ==============================
   ETF Follow (Core Index) (PC)
   Namespaced to avoid .container* conflicts
   ============================== */
.etf-follow {
  padding: 120rem 0;
  background: linear-gradient(180deg, #16161a 0%, #2b2b33 100%);
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__inner {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.etf-follow__header {
  text-align: center;
  max-width: 1200rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16rem;
  margin-bottom: 60rem;
}

.etf-follow__header h3 {
  color: rgba(255, 255, 255, 0.8);
}

.etf-follow__tabs {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8rem;
  border-radius: var(--ebc-corner-radius-full, 999rem);
  margin: 0 auto 40rem;
}

.etf-follow__tab {
  height: 40rem;
  padding: 8rem 24rem;
  border-radius: var(--ebc-corner-radius-full, 999rem);
  border: 1rem solid rgba(255, 255, 255, 0.16);
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 400;
  cursor: pointer;

}

.etf-follow__tab.is-active {
  border-color: var(--ebc-brand-secondary-red, #a52933);
  background: var(--ebc-brand-secondary-red, #a52933);
  color: var(--ebc-text-primary_white, #fff);
  font-weight: 500;
}

.etf-follow__tab:disabled {
  cursor: not-allowed;
  opacity: 1;
}

.etf-follow__grid {
  display: flex;
  gap: 24rem;
  align-items: stretch;
}

.etf-follow__panels {
  width: 100%;
}

.etf-follow__panel {
  display: none;
}

.etf-follow__panel.is-active {
  display: block;
}

.etf-follow__historyBox {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  padding: 40rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 28rem;
  position: relative;
  overflow: visible;
}

.etf-follow__historyRank {
  display: flex;
  flex-direction: column;
  gap: 20rem;
}

.etf-follow__historySelect {
  display: inline-flex;
  align-items: center;
  gap: 8rem;
  border: 0;
  background: transparent;
  color: var(--ebc-text-primary_white, #fff);
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 500;
  padding: 0;
  width: fit-content;
  cursor: pointer;
}

.etf-follow__historySelectArrow {
  width: 0;
  height: 0;
  border-left: 5rem solid transparent;
  border-right: 5rem solid transparent;
  border-top: 6rem solid rgba(255, 255, 255, 0.8);
  transform: translateY(1rem);
}

.etf-follow__historyMenu {
  position: absolute;
  top: 72rem;
  left: 40rem;
  width: 220rem;
  background: #fff;
  border-radius: 12rem;
  padding: 12rem 0;
  box-shadow: 0 12rem 32rem rgba(0, 0, 0, 0.35);
  z-index: 20;
}

.etf-follow__historyOption {
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 10rem 16rem;
  font-size: 14rem;
  line-height: 20rem;
  font-weight: 400;
  color: #111;
  cursor: pointer;
}

.etf-follow__historyOption:hover {
  background: rgba(0, 0, 0, 0.06);
}

.etf-follow__historyTop1 {
  /* background: #1f1f1f; */
  /* border-radius: var(--ebc-corner-radius-rc16, 16rem); */
  /* padding: 40rem; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24rem;
}

.etf-follow__historyTop1Left {
  display: flex;
  align-items: center;
  gap: 28rem;
  min-width: 0;
}

.etf-follow__historyMedal {
  width: 38rem;
  height: 48rem;
  display: block;
  object-fit: contain;
}

.etf-follow__historyTop1Info {
  display: flex;
  flex-direction: column;
  gap: 6rem;
  min-width: 0;
}

.etf-follow__historyTop1Symbol {
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
  color: var(--ebc-text-primary_white, #fff);
  white-space: nowrap;
}

.etf-follow__historyTop1Desc {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 520rem;
}

.etf-follow__historyTop1Value {
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: #00d89e;
  white-space: nowrap;
}

.etf-follow__historyTitle {
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 400;
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__historyHeader {
  display: flex;
  align-items: flex-start;
  gap: 0;
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.32);
}

.etf-follow__historyCol--rank,
.etf-follow__historyCol--symbol {
  flex: 1 1 0;
}

.etf-follow__historyCol--desc {
  width: 256rem;
}

.etf-follow__historyCol--ret {
  width: 200rem;
  text-align: right;
}

.etf-follow__historyDivider {
  height: 1rem;
  background: rgba(255, 255, 255, 0.16);
}

.etf-follow__historyList {
  display: flex;
  flex-direction: column;
  gap: 20rem;
}

.etf-follow__historyRow {
  display: flex;
  align-items: flex-start;
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__historyCell--rank,
.etf-follow__historyCell--symbol {
  flex: 1 1 0;
}

.etf-follow__historyCell--desc {
  width: 256rem;
}

.etf-follow__historyCell--ret {
  width: 200rem;
  text-align: right;
  font-weight: 500;
  color: #00d89e;
}

.etf-follow__historyFooter {
  margin-top: 0;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.25);
  text-align: center;
}

.etf-follow__volBox {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  padding: 40rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32rem;
}

.etf-follow__volTabs {
  display: inline-flex;
  gap: 8rem;
  align-items: center;
  border-radius: var(--ebc-corner-radius-full, 999rem);
  flex-wrap: wrap;
}

.etf-follow__volTab {
  border: 1rem solid rgba(255, 255, 255, 0.16);
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  padding: 8rem 16rem;
  border-radius: var(--ebc-corner-radius-full, 999rem);
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  cursor: pointer;
}

.etf-follow__volTab.is-active {
  border-color: var(--ebc-brand-accent-coral, #ff4b4e);
  color: var(--ebc-brand-accent-coral, #ff4b4e);
  font-weight: 500;
}

.etf-follow__volContent {
  display: flex;
  flex-direction: column;
  gap: 24rem;
}

.etf-follow__volHead {
  display: flex;
  flex-direction: column;
  gap: 12rem;
}

.etf-follow__volTitle {
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__volDesc {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.etf-follow__volDivider {
  height: 1rem;
  background: rgba(255, 255, 255, 0.16);
}

.etf-follow__volSectionTitle {
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 400;
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__volList {
  margin-top: 12rem;
  display: flex;
  flex-direction: column;
  gap: 12rem;
}

.etf-follow__volRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16rem;
}

.etf-follow__volLeft {
  display: flex;
  align-items: center;
  gap: 12rem;
  min-width: 0;
}

.etf-follow__volPill {
  background: #1f1f1f;
  border-radius: var(--ebc-corner-radius-rc08, 8rem);
  padding: 4rem 12rem;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: #fff;
  white-space: nowrap;
}

.etf-follow__volName {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.64);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.etf-follow__volBeta {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

.etf-follow__volHelpTitle {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.64);
  white-space: pre;
  margin-bottom: 4rem;
}

.etf-follow__volHelpText {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.32);
}

.etf-follow__hotRows {
  display: flex;
  flex-direction: column;
  gap: 24rem;
}

.etf-follow__hotRow {
  display: flex;
  gap: 24rem;
  align-items: stretch;
}

.etf-follow__hotCard {
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  overflow: hidden;
  padding: 40rem;
  display: flex;
  flex-direction: column;
  gap: 32rem;
  position: relative;
  background: rgba(255, 255, 255, 0.05);

}

@media (min-width: 996px) {
  .etf-follow__hotCard:hover {
    background: #3b3b42;
  }
}


.etf-follow__hotCard--lg {
  flex: 0 0 588rem;
  min-height: 220rem;
}

.etf-follow__hotCard--sm {
  flex: 0 0 282rem;
}

.etf-follow__hotHead {
  display: flex;
  flex-direction: column;
  gap: 12rem;
  max-width: 270rem;
}

.etf-follow__hotTitle {
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__hotDesc {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);

}

.etf-follow__pillGroup {
  display: inline-flex;
  gap: 8rem;
  align-items: center;
  flex-wrap: wrap;
}

.etf-follow__pill {
  background: #1f1f1f;
  color: #fff;
  font-size: 14rem;
  line-height: 22rem;
  padding: 4rem 12rem;
  border-radius: var(--ebc-corner-radius-rc08, 8rem);
  font-weight: 400;
  user-select: none;
}

.etf-follow__hotCard:hover .etf-follow__pill {
  background: #fff;
  color: #010101;
  font-weight: 500;
}

.etf-follow__hotArt {
  position: absolute;
  pointer-events: none;
  user-select: none;
}

.etf-follow__hotArt--sp {
  right: 40rem;
  top: 40rem;
  width: 170rem;
  height: auto;
}

.etf-follow__hotArt--em {
  right: 40rem;
  top: 40rem;
  width: 170rem;
  height: auto;
}

.etf-follow__card {
  flex: 0 0 calc((100% - 24rem) / 2);
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  overflow: hidden;
  padding: 40rem;
  display: flex;
  flex-direction: column;
  gap: 32rem;
  background: rgba(255, 255, 255, 0.05);

}

.etf-follow__card:hover {
  background: #3b3b42;
}



.etf-follow__cardHead {
  display: flex;
  flex-direction: column;
  gap: 12rem;
}

.etf-follow__cardTitle {
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
  color: var(--ebc-text-primary_white, #fff);
  word-break: break-word;
}

.etf-follow__cardDesc {
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  word-break: break-word;
}

.etf-follow__divider {
  height: 1rem;
  background: rgba(255, 255, 255, 0.1);
}

.etf-follow__cardBody {
  display: flex;
  flex-direction: column;
  gap: 24rem;
}

.etf-follow__symbolTabs {
  display: inline-flex;
  gap: 8rem;
  align-items: center;
  border-radius: var(--ebc-corner-radius-full, 999rem);
}

.etf-follow__symbolTab {
  padding: 8rem 16rem;
  border-radius: var(--ebc-corner-radius-full, 999rem);
  border: 1rem solid rgba(255, 255, 255, 0.16);
  background: transparent;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}

.etf-follow__symbolTab.is-active {
  border-color: var(--ebc-brand-accent-coral, #ff4b4e);
  color: var(--ebc-brand-accent-coral, #ff4b4e);
  font-weight: 500;
}

.etf-follow__meta {
  display: flex;
  align-items: center;
  gap: 64rem;
  flex-wrap: wrap;
}

.vi .etf-follow__meta {
  gap: 20rem;
}

.pt .etf-follow__meta,
.mn .etf-follow__meta,
.es .etf-follow__meta {
  gap: 32rem;
}

.etf-follow__metaItem {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.etf-follow__metaLabel {
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.etf-follow__metaValue {
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 500;
  color: var(--ebc-text-primary_white, #fff);
  white-space: nowrap;
}

.etf-follow__perf {
  display: flex;
  gap: 8rem;
  height: 120rem;
  width: 100%;
}

.etf-follow__perfItem {
  flex: 1;
  border-radius: var(--ebc-corner-radius-rc08, 8rem);
  background: rgba(35, 34, 34, 0.3);
  padding: 12rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  align-items: center;
  justify-content: center;
  transition: background 160ms ease;
}

@media (min-width: 996px) {

  /* .etf-follow__perfItem.is-active, */
  .etf-follow__perfItem:hover {
    background: #1f1f1f;
  }



}


.etf-follow__perfLabel {
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 400;
  color: var(--ebc-text-primary_white, #fff);
}

.etf-follow__perfValue {
  font-size: 18rem;
  line-height: 26rem;
  font-weight: 700;
  color: #00d89e;
}

.etf-follow__note {
  text-align: center;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.25);
  margin-top: 40rem;
  max-width: 980rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 24rem;
}

@media (min-width: 996px) {
  .vi .etf-follow h2 {
    font-size: 42rem;
  }

  .mn .etf-follow h2,
  .vi .container2 h2,
  .vi .etf-giants h2,
  .pt .container2 h2 {
    font-size: 44rem;
  }

  .id .etf-giants h2,
  .mn .container2 h2 {
    font-size: 40rem;
  }
}

@media (max-width: 996px) {
  .etf-follow {
    /* 375px design values x2 */
    padding: 160rem 0;
  }

  .etf-follow__inner {
    padding: 0 32rem;
    box-sizing: border-box;
  }

  .etf-follow__header {
    max-width: 686rem;
    gap: 16rem;
    margin-bottom: 80rem;
  }

  .etf-follow__header h2 {
    font-size: 48rem;
    line-height: 64rem;
  }

  .mn .etf-follow h2,
  .ar .container2 h2,
  .es .container2 h2,
  .mn .container2 h2,
  .vi .container2 h2,
  .vi .container4 h2,
  .jp .container4 h2,
  .ru .openAccountPart h2,
  .ru .etf-giants h2,
  .id .etf-giants h2,
  .vi .etf-follow__header h2 {
    font-size: 42rem;
  }

  .jp .etf-giants h2 {
    font-size: 40rem;
  }

  .mn .container4 h2,
  .mn .etf-efficient h2,
  .pt .etf-giants h2,
  .ru .container2 h2,
  .ru .container4 h2 {
    font-size: 38rem;
  }

  .etf-follow__header h3 {
    font-size: 24rem;
    line-height: 40rem;
    color: rgba(255, 255, 255, 0.64);
  }

  .etf-follow__tabs {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;
    gap: 16rem;
    margin: 0 0 80rem;
    border-radius: 0;
    /* Hide bottom scrollbar but keep scrolling */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE/Edge legacy */
  }

  .etf-follow__tabs::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .etf-follow__tab {
    flex: 0 0 auto;
    white-space: nowrap;
    height: auto;
    padding: 16rem 32rem;
    border-width: 1rem;
    font-size: 24rem;
    line-height: 32rem;
    color: rgba(255, 255, 255, 0.64);
  }

  .etf-follow__grid {
    flex-direction: column;
  }

  .etf-follow__card {
    flex: 1 1 auto;
    padding: 46.666rem;
    gap: 56rem;
    background: #3b3b42;
  }

  .etf-follow__card:hover {
    background: #3b3b42;
  }

  .etf-follow__cardHead {
    gap: 14rem;
  }

  .etf-follow__cardTitle {
    font-size: 32rem;
    line-height: 38rem;
  }

  .etf-follow__cardDesc {
    font-size: 24rem;
    line-height: 28rem;
  }

  .etf-follow__symbolTabs {
    gap: 16rem;
  }

  .etf-follow__symbolTab {
    height: 72rem;
    padding: 12rem 16rem;
    border-width: 1rem;
    font-size: 24rem;
    line-height: 26rem;
    display: block;
    flex: 0 0 180rem;
  }

  .etf-follow__divider {
    margin-top: -14rem;
  }

  .etf-follow__cardBody {
    gap: 28rem;
  }

  .etf-follow__symbolTabs {
    margin-bottom: 28rem;
  }

  .etf-follow__meta {
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 10rem;
  }

  .es .etf-follow__meta {
    gap: 10rem;
  }

  .etf-follow__metaItem {
    min-width: 0;
    gap: 8rem;
  }

  .pt .etf-follow__metaItem,
  .mn .etf-follow__metaItem,
  .es .etf-follow__metaItem,
  .id .etf-follow__metaItem {
    flex: 1;
  }

  .etf-follow__metaLabel {
    font-size: 24rem;
    line-height: 26rem;
  }

  .etf-follow__metaValue {
    font-size: 24rem;
    line-height: 28rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .etf-follow__perf {
    height: auto;
    flex-wrap: wrap;
    gap: 9rem;
  }

  .etf-follow__perfItem {
    flex: 0 0 calc((100% - 9rem) / 2);
    padding: 32rem 14rem;
    border-radius: 16rem;
    gap: 8rem;
  }




  .etf-follow__perfLabel {
    font-size: 24rem;
    line-height: 28rem;
  }

  .etf-follow__perfValue {
    font-size: 28rem;
    line-height: 30rem;
  }

  .etf-follow__hotRow {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 32rem;
  }

  .etf-follow__hotRow:nth-child(2)>div {
    order: 2;
  }

  .etf-follow__hotRow:nth-child(2)>div:last-child {
    order: 1;
  }

  .etf-follow__hotCard--lg,
  .etf-follow__hotCard--sm {
    flex: 1 1 auto;
  }

  .etf-follow__hotCard {
    border-radius: 28rem;
    padding: 46.666rem;
    gap: 40rem;
    background: #2f2f36;
  }

  .etf-follow__hotCard--lg {
    flex: 0 0 100%;
    min-height: auto;
  }

  .etf-follow__hotCard--sm {
    flex: 0 0 calc((100% - 32rem) / 2);
    /* background: #2a2a30; */
  }

  .etf-follow__hotHead {
    gap: 16rem;
    max-width: none;
  }

  .etf-follow__hotTitle {
    font-size: 32rem;
    line-height: 38rem;
  }

  .mn .etf-follow__hotCard--lg .etf-follow__hotTitle,
  .pt .etf-follow__hotCard--lg .etf-follow__hotTitle {
    max-width: 60%;
  }

  .etf-follow__hotDesc {
    font-size: 24rem;
    line-height: 32rem;
    color: rgba(255, 255, 255, 0.64);
    max-width: 320rem;
  }

  .etf-follow__note {
    color: rgba(255, 255, 255, 0.25);
    text-align: center;
    font-size: 24rem;
    font-weight: 400;
    line-height: 32rem;
    /* 133.333% */
    margin-top: 24rem;
    padding: 0;
  }

  .etf-follow__pillGroup {
    gap: 16rem;
  }

  .etf-follow__pill {
    font-size: 24rem;
    line-height: 26rem;
    padding: 8rem 16rem;
    border-radius: 10rem;
  }

  .etf-follow__hotArt--sp,
  .etf-follow__hotArt--em {
    right: 48rem;
    top: 48rem;
    width: 200rem;
  }

  .ar .etf-follow__historyTop1Value,
  .ar .etf-follow__hotArt--sp,
  .ar .etf-follow__hotArt--em {
    right: unset;
    left: 48rem;
  }

  .ar .etf-follow__historyMenu {
    left: unset;
    right: 46rem;
  }

  .etf-follow__historyBox {
    padding: 46rem;
    border-radius: 24rem;
    gap: 48rem;
    background: #303037;
  }

  .etf-follow__historySelect {
    width: fit-content;
    justify-content: flex-start;
    gap: 8rem;
    font-size: 24rem;
    line-height: 28rem;
    color: rgba(255, 255, 255, 0.8);
    padding-block: 15rem;
  }

  .es .etf-follow__historySelect,
  .ru .etf-follow__historySelect,
  .ug .etf-follow__historySelect {
    max-width: 45%;
  }

  .etf-follow__historySelectArrow {
    display: block;
    border-left-width: 10rem;
    border-right-width: 10rem;
    border-top-width: 12rem;
  }

  .etf-follow__historyMenu {
    top: 96rem;
    left: 46rem;
    width: 252rem;
    border-radius: 16rem;
    padding: 16rem 0;
  }

  .etf-follow__historyOption {
    padding: 16rem 24rem;
    font-size: 24rem;
    line-height: 36rem;
  }

  .etf-follow__historyTop1 {
    background: transparent;
    padding: 0;
    border-radius: 0;
    gap: 14rem;
    justify-content: flex-start;
  }

  .etf-follow__historyMedal {
    width: 64rem;
    height: 80rem;
  }

  .etf-follow__historyTop1Symbol {
    font-size: 32rem;
    line-height: 38rem;
  }

  .etf-follow__historyTop1Desc {
    font-size: 24rem;
    line-height: 28rem;
    max-width: 100%;
    white-space: normal;
  }

  .etf-follow__historyTop1Value {
    font-size: 48rem;
    line-height: 56rem;
    position: absolute;
    top: 46rem;
    right: 46rem;
  }

  .etf-follow__historyRank {
    gap: 24rem;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16rem;
    scrollbar-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.24);
    scrollbar-width: thin;
  }

  .etf-follow__historyRank::-webkit-scrollbar {
    height: 6rem;
  }

  .etf-follow__historyRank::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.24);
    border-radius: 999rem;
  }

  .etf-follow__historyRank::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 999rem;
  }

  .etf-follow__historyTitle {
    font-size: 24rem;
    line-height: 28rem;
    font-weight: 400;
  }

  .etf-follow__historyDivider {
    display: none;
  }

  .etf-follow__historyHeader {
    font-size: 24rem;
    line-height: 28rem;
    padding-bottom: 24rem;
    border-bottom: 1rem solid rgba(255, 255, 255, 0.16);

    margin-top: 32rem;
  }

  .etf-follow__historyRow {
    padding: 32rem 0;
    border-bottom: 1rem solid rgba(255, 255, 255, 0.16);
  }

  .etf-follow__historyList {
    gap: 0;
    padding-bottom: 48rem;
  }

  .etf-follow__historyHeader,
  .etf-follow__historyRow {
    display: grid;
    grid-template-columns: 116rem 150rem 360rem 170rem;
    column-gap: 40rem;
    align-items: center;
    width: 956rem;
    box-sizing: border-box;
  }

  .etf-follow__historyCol,
  .etf-follow__historyCell {
    width: auto;
    flex: initial;
    min-width: 0;
  }

  .etf-follow__historyCell {
    font-size: 28rem;
    line-height: 44rem;
  }

  .etf-follow__historyCell--rank {
    font-size: 32rem;
    line-height: 48rem;
    font-weight: 500;
  }

  .etf-follow__historyCell--symbol,
  .etf-follow__historyCell--desc {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .etf-follow__historyCol--ret,
  .etf-follow__historyCell--ret {
    text-align: right;
  }

  .etf-follow__historyFooter {
    font-size: 24rem;
    line-height: 32rem;
    margin-top: 0;
    padding-top: 24rem;
  }

  .etf-follow__volBox {
    padding: 46rem;
    border-radius: 24rem;
    gap: 40rem;
    background: #303037;
  }

  .etf-follow__volTabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16rem;
    width: 100%;
  }

  .etf-follow__volTab {
    min-height: 72rem;
    padding: 12rem 24rem;
    border-width: 1rem;
    font-size: 24rem;
    line-height: 26rem;
    /* white-space: nowrap; */
  }

  .etf-follow__volContent {
    gap: 48rem;
  }

  .etf-follow__volHead {
    gap: 14rem;
  }

  .etf-follow__volTitle {
    font-size: 32rem;
    line-height: 38rem;
  }

  .etf-follow__volDesc {
    font-size: 24rem;
    line-height: 28rem;
  }

  .etf-follow__volDivider {
    background: rgba(255, 255, 255, 0.08);
  }

  .etf-follow__volSectionTitle {
    font-size: 24rem;
    line-height: 28rem;
  }

  .etf-follow__volList {
    margin-top: 24rem;
    gap: 32rem;
  }

  .etf-follow__volRow {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    row-gap: 16rem;
    column-gap: 32rem;
    align-items: center;
  }

  .etf-follow__volLeft {
    display: contents;
  }

  .etf-follow__volPill {
    grid-column: 1 / -1;
    justify-self: start;
    padding: 8rem 16rem;
    border-radius: 10rem;
    font-size: 24rem;
    line-height: 26rem;
  }

  .etf-follow__volName {
    grid-column: 1;
    font-size: 24rem;
    line-height: 32rem;
  }

  .etf-follow__volBeta {
    grid-column: 2;
    font-size: 24rem;
    line-height: 32rem;
  }

  .etf-follow__volHelpTitle {
    font-size: 24rem;
    line-height: 38rem;
    margin-bottom: 16rem;
  }

  .etf-follow__volHelpText {
    display: flex;
    flex-direction: column;
    gap: 16rem;
    font-size: 24rem;
    line-height: 32rem;
    color: rgba(255, 255, 255, 0.25);
  }
}

/* ==============================
   ETF Issuers / Giants (PC)
   Namespaced to avoid .container* conflicts
   ============================== */
.etf-giants {
  padding: 120rem 0;
  background: var(--ebc-neutral-bg_b, #f7f7f7);
}

.etf-giants__inner {
  display: flex;
  flex-direction: column;
  gap: 60rem;
}

.etf-giants__header {
  text-align: center;
  max-width: 1200rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16rem;
}

.th .etf-giants__header h2,
.th .container2 h2 {
  font-size: 42rem;
}

.etf-giants__header h3 {
  color: var(--ebc-text-secondary);
}

.etf-giants__grid {
  display: flex;
  gap: 24rem;
  align-items: stretch;
}

.etf-giants__card {
  flex: 0 0 calc((100% - 72rem) / 4);
  background: var(--ebc-neutral-bg_a, #fff);
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  overflow: hidden;
  min-height: 426rem;
  display: flex;
  flex-direction: column;
  transition: transform 180ms ease, box-shadow 180ms ease;
  will-change: transform;
}

.etf-giants__card:hover {
  transform: translateY(-10rem);
  box-shadow: 0 18rem 48rem rgba(0, 0, 0, 0.18);
}

.etf-giants__top {
  padding: 40rem 32rem 24rem;
  box-sizing: border-box;
  color: var(--ebc-text-primary_white, #fff);
  display: flex;
  flex-direction: column;
  gap: 12rem;
}

@media (min-width: 996px) {

  .ar .etf-giants__top,
  .jp .etf-giants__top,
  .vi .etf-giants__top,
  .th .etf-giants__top,
  .en .etf-giants__top {
    min-height: 190rem;
  }

  .mn .etf-giants__top {
    min-height: 232rem;
  }

  .ru .etf-giants__top,
  .ug .etf-giants__top,
  .id .etf-giants__top,
  .pt .etf-giants__top,
  .es .etf-giants__top {
    min-height: 210rem;
  }
}

@media (max-width: 996px) {

  .ar .etf-giants__top,
  .jp .etf-giants__top,
  .vi .etf-giants__top,
  .th .etf-giants__top,
  .en .etf-giants__top {
    min-height: 380rem;
  }

  .mn .etf-giants__top {
    min-height: 464rem;
  }

  .ru .etf-giants__top,
  .ug .etf-giants__top,
  .id .etf-giants__top,
  .pt .etf-giants__top,
  .es .etf-giants__top {
    min-height: 420rem;
  }
}

.etf-giants__card--black .etf-giants__top {
  background: #000;
}

.etf-giants__card--red .etf-giants__top {
  background: #bb001c;
}

.etf-giants__card--blue .etf-giants__top {
  background: #001aff;
}

.etf-giants__card--indigo .etf-giants__top {
  background: #33348e;
}

.etf-giants__topRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12rem;
}

.etf-giants__logoBox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;
}

.etf-giants__logo {
  width: auto;
  height: auto;
  max-height: 28rem;
  display: block;
  object-fit: contain;
}

/* Per-logo widths (match design assets), height auto */
.etf-giants__card--black .etf-giants__logo {
  width: 85rem;
}

.etf-giants__card--red .etf-giants__logo {
  width: 110rem;
}

.etf-giants__card--blue .etf-giants__logo {
  width: 88rem;
}

.etf-giants__card--indigo .etf-giants__logo {
  width: 135rem;
}

@media (min-width: 997px) {
  .etf-giants__top {
    /* Keep tops visually consistent, allow locale expansion */
    min-height: 148rem;
  }
}

.etf-giants__topName {
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 500;
  white-space: nowrap;
}

.etf-giants__topDesc {
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.etf-giants__meta {
  padding: 24rem 32rem 0;
}

.etf-giants__stats {
  margin-top: 0;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16rem;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
}

.es .etf-giants__stats,
.vi .etf-giants__stats {
  gap: 0;
}

.ru .etf-giants__stats div {
  white-space: nowrap;
}

.etf-giants__statsLabels {
  color: var(--ebc-text-secondary, rgba(0, 0, 0, 0.64));
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.etf-giants__statsValues {
  color: var(--ebc-text-primary, #000);
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4rem;
  white-space: nowrap;
}

.etf-giants__featured {
  margin: 40rem 20rem 24rem;
  padding: 24rem;
  border-radius: var(--ebc-corner-radius-rc08, 8rem);
  background: var(--ebc-neutral-bg_b, #f7f7f7);
  position: relative;
  overflow: hidden;
}

.etf-giants__featuredTag {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6rem;
  background: var(--brand-accent-coral, #ff4b4e);
  color: var(--ebc-text-primary_white, #fff);
  font-size: 12rem;
  line-height: 12rem;
  font-weight: 400;
  border-bottom-left-radius: 8rem;
}

@media (min-width: 996px) {
  .etf-giants__featuredTag {
    max-width: 50%;
  }

  .ar .etf-giants__featuredTag {
    right: unset;
    left: 0;
    border-bottom-right-radius: 8rem;
    border-bottom-left-radius: 0;
  }
}

.etf-giants__ticker {
  font-size: 20rem;
  line-height: 28rem;
  font-weight: 700;
  color: var(--ebc-text-primary, #000);
}

.etf-giants__featuredRow {
  margin-top: 16rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8rem;
}

.etf-giants__metric {
  width: 100%;
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  /* align-items: center; */
  gap: 4rem;
}

.id .etf-giants__stats .etf-giants__statsLabels div:first-child,
.es .etf-giants__stats .etf-giants__statsLabels div:first-child,
.vi .etf-giants__stats .etf-giants__statsLabels div:first-child {
  white-space: nowrap;
}

@media screen and (min-width: 996px) {
  .etf-giants__metric {
    flex: 1;
  }

}

.etf-giants__metricLabel {
  font-size: 14rem;
  line-height: 18rem;
  font-weight: 400;
  color: var(--ebc-text-secondary, rgba(0, 0, 0, 0.64));
}

.etf-giants__metricValue {
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 700;
  color: var(--ebc-text-primary, #000);
  white-space: nowrap;
  transform: translateY(-3rem);
}

.etf-giants__metricValue--up {
  color: #00ac47;
}

.etf-giants__note {
  text-align: center;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
}

@media (max-width: 996px) {
  .th .openAccountPart h2 {
    font-size: 40rem;
  }

  .etf-giants__logo {
    max-height: unset;
  }

  .etf-giants__card--black .etf-giants__logo {
    width: 170rem;
  }

  .etf-giants__card--red .etf-giants__logo {
    width: 220rem;
  }

  .etf-giants__card--blue .etf-giants__logo {
    width: 176rem;
  }

  .etf-giants__card--indigo .etf-giants__logo {
    width: 270rem;
  }

  .etf-giants {
    /* 375px design values x2 */
    padding: 160rem 0;
  }

  .etf-giants__inner {
    gap: 80rem;
    padding: 0 32rem;
    box-sizing: border-box;
  }

  .etf-giants__inner h2 {
    font-size: 44rem;
  }

  .etf-giants__header {
    max-width: 686rem;
    gap: 16rem;
  }

  .etf-giants__grid {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    /* 375px design values x2 */
    scroll-padding-left: 32rem;
    padding: 0 32rem;
    margin: 0 -32rem;
    gap: 48rem;

    /* Hide bottom scrollbar but keep scrolling */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE/Edge legacy */
  }

  .etf-giants__grid::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .etf-giants__card {
    flex: 0 0 564rem;
    scroll-snap-align: start;
    min-height: 852rem;
    position: relative;
    padding-bottom: 48rem;
  }

  /* Hover lift feels odd on touch devices */
  .etf-giants__card:hover {
    transform: none;
    box-shadow: none;
  }

  .etf-giants__top {
    padding: 80rem 64rem 48rem;
    gap: 24rem;
    min-height: 296rem;
  }

  .etf-giants__topName {
    font-size: 32rem;
    line-height: 48rem;
    max-width: 320rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .etf-giants__topDesc {
    font-size: 28rem;
    line-height: 44rem;
  }

  .etf-giants__meta {
    padding: 48rem 64rem 0;
  }

  .etf-giants__stats {
    gap: 32rem;
    font-size: 28rem;
    line-height: 44rem;
  }

  .etf-giants__statsLabels,
  .etf-giants__statsValues {
    gap: 8rem;
  }

  .etf-giants__featured {
    margin: 0;
    padding: 48rem;
    border-radius: var(--ebc-corner-radius-rc16, 16rem);
    position: static;
    margin-top: 80rem;
    inset: 0;
    margin-inline: 40rem;
  }

  .etf-giants__featuredTag {
    padding: 12rem;
    font-size: 24rem;
    line-height: 40rem;
    border-bottom-left-radius: 16rem;
  }

  .etf-giants__ticker {
    font-size: 40rem;
    line-height: 56rem;
  }

  .etf-giants__featuredRow {
    margin-top: 32rem;
    gap: 32rem;
    justify-content: space-between;
    /* flex-wrap: wrap; */
  }

  .etf-giants__metricLabel {
    font-size: 24rem;
    line-height: 32rem;
  }

  .etf-giants__metricValue {
    font-size: 32rem;
    line-height: 48rem;
    transform: translateY(-8rem);

  }
}

.container2 {
  margin-top: 0;
}

.ar .container4 .QA-list .QA-item.showList .QA-content {
  padding-right: 0;
}

.ar .container4 .QA-list .QA-li {
  text-align: right;
  padding-right: 18rem;
}

.ar .container4 .QA-list .QA-li::before {
  left: unset;
  right: 0;
}

#pageContainer .tableBtn {
  margin-top: 60rem;
  min-width: 180rem;
  display: flex;
  box-sizing: border-box;
}

#pageContainer .tableBtn:hover {
  color: var(--ebc-text-primary_white);
}

@media (max-width: 996px) {
  #pageContainer .tableBtn {
    height: 80rem;
    font-size: 28rem;
    line-height: 0rem;
    margin: 80rem auto 0;
  }
}
/* shareHotModule */
.shareHotModule{
  position: relative;
  overflow: hidden;
  padding: 120rem 0 88rem;
}
.shareHotModule-bg{
  position: absolute;
  inset: 0;
  z-index: 0;
}
.shareHotModule-bg img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}

.shareHotModule-content{
  position: relative;
  z-index: 2;
  text-align: center;
}
.shareHotModule-title{
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-benefits{
  margin-top: 28rem;
  color: var(--ebc-text-primary_white, #fff);
  font-weight: 700;
}
.shareHotModule-benefit + .shareHotModule-benefit{
  margin-left: 28.778rem;
}
.shareHotModule-benefitNum{
  color: var(--ebc-brand-accent-coral, #ff4b4e);
  font-size: 80rem;
  line-height: 80.579rem;
  margin-right: 4rem;
  
}
@media (min-width: 996px) {
.shareHotModule{
margin-top: -64rem;
}
  .shareHotModule-benefitNum,
  .shareHotModule-benefitText{
    height: 80rem;
    display: inline-block;
    vertical-align: bottom
  }
}
.shareHotModule-benefitText{
  font-size: 64rem;
  line-height: 80.579rem;
}
.shareHotModule-countdown{
  margin-top: 60rem;
}
.shareHotModule-countdownLabel{
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-countdownRow{
  margin-top: 12rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14rem;
}
.shareHotModule-timeBox{
  width: 100rem;
  height: 100rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 14rem;
  background: rgba(255,255,255,0.1);
}
.shareHotModule-timeBox span{
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-unit{
  font-size: 24rem;
  line-height: 32rem;
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-ruleLink{
  margin-top: 60rem;
  display: inline-flex;
  align-items: center;
  color: var(--ebc-text-secondary_white, rgba(255,255,255,0.64));
  text-decoration: none;
}
.shareHotModule-ruleIcon{
  display: inline-block;
  margin-left: 4rem;
  transform: translateY(-6rem);
}

@media (max-width: 996px) {
  .shareHotModule{
    padding: 160rem 0;
  }
  .shareHotModule-benefits{
    margin-top: 20rem;
    line-height: normal;
  }
  .shareHotModule-benefit + .shareHotModule-benefit{
    margin-left: 24rem;
  }
  .shareHotModule-benefitNum{
    font-size: 72rem;
    line-height: 90.804rem;
    margin-right: 4rem;
  }
  .shareHotModule-benefitText{
    font-size: 64rem;
    line-height: normal;
  }
  .shareHotModule-countdown{
    margin-top: 80rem;
  }
  .shareHotModule-countdownRow{
    gap: 12rem;
    margin-top: 24rem;
  }
  .shareHotModule-timeBox{
    width: 96rem;
    height: 96rem;
    border-radius: 14.406rem;
  }
  .shareHotModule-timeBox span{
    font-size: 36rem;
    line-height: 52rem;
  }
  .shareHotModule-unit{
    font-size: 28rem;
    line-height: 44rem;
  }
  .shareHotModule-ruleIcon{
    transform: translateY(-10rem);
  }
  .shareHotModule-ruleLink{
    margin-top: 80rem;
  }
}

/* shareHotRuleModal */
.body-no-scroll{
  overflow: hidden;
  position: fixed;
  width: 100%;
}
.shareHotRuleModal{
  display: none;
  position: fixed;
  inset: 0;
  z-index: 999999999;
}
.shareHotRuleModal.is-open{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32rem;
}
.shareHotRuleModal-bg{
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.64);
}
.shareHotRuleModal-dialog{
  position: relative;
  width: 840rem;
  max-width: calc(100vw - 64rem);
  background: #fff;
  border: 1rem solid rgba(255,255,255,0.2);
  border-radius: var(--ebc-corner-radius-rc16, 16rem);
  box-shadow: 20rem 40rem 60rem 0 rgba(0,0,0,0.1);
  padding: 32rem;
  overflow: hidden;
}
.shareHotRuleModal-title{
  color: var(--ebc-text-primary, #000);
}
.shareHotRuleModal-close{
  position: absolute;
  top: 32rem;
  right: 32rem;
  width: 32rem;
  height: 32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  color: rgba(0,0,0,0.48);
}
.shareHotRuleModal-close .icon-close{
  font-size: 24rem;
}
.shareHotRuleModal-body{
  margin-top: 32rem;
}
.shareHotRuleModal-item + .shareHotRuleModal-item{
  margin-top: 20rem;
}
.shareHotRuleModal-itemTitle{
  color: var(--ebc-text-primary, #000);
  line-height: 24rem;
}
.shareHotRuleModal-itemText{
  margin-top: 4rem;
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
  line-height: 22rem;
}
.shareHotRuleModal-itemText p{
  margin: 0;
}
.shareHotRuleModal-itemText p + p{
  margin-top: 4rem;
}

@media (max-width: 996px) {
  ::v-deep(.scrollTabWrapper){
    padding-block: 30rem;
    margin-top: 0;
    background: var(--ebc-neutral-bg_c);
  }
  ::v-deep(.scrollTab .tabItem){
    background: var(--ebc-neutral-bg_a);
  }
  ::v-deep(.scrollTab .tabItem.active){
    background: var(--ebc-basecolor-active-500);
  }
  /* 移动端 bottom sheet（375 设计稿数值 ×2） */
  .shareHotRuleModal.is-open{
    align-items: flex-end;
    justify-content: center;
    padding: 0;
  }
  .shareHotRuleModal-dialog{
    width: 100vw;
    max-width: 100vw;
    border-radius: 32rem 32rem 0 0;
    padding: 32rem;
    padding-top: 60rem;
    padding-bottom: 40rem;
    max-height: 80vh;
    overflow: auto;
  }
  .shareHotRuleModal-close{
    top: 64rem;
    right: 64rem;
    width: 64rem;
    height: 64rem;
  }
  .shareHotRuleModal-close .icon-close{
    font-size: 48rem;
  }
  .shareHotRuleModal-body{
    margin-top: 64rem;
  }
  .shareHotRuleModal-item + .shareHotRuleModal-item{
    margin-top: 40rem;
  }
  .shareHotRuleModal-itemTitle{
    line-height: 48rem;
  }
  .shareHotRuleModal-itemText{
    margin-top: 8rem;
    line-height: 44rem;
  }
  .shareHotRuleModal-itemText p + p{
    margin-top: 8rem;
  }
}
</style>